import React, { useEffect, useRef, useState } from 'react'
import { FiDownload, FiRefreshCw } from 'react-icons/fi'
import { LocationOn, Lock, LockOpen } from '@mui/icons-material'
import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import CloseIcon from '@mui/icons-material/Close'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import BadgeIcon from '@mui/icons-material/Badge'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import InfoIcon from '@mui/icons-material/Info'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import VisibilityIcon from '@mui/icons-material/Visibility'
import BlockIcon from '@mui/icons-material/Block'
import VerifiedIcon from '@mui/icons-material/Verified'
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt'
import NoAccountsIcon from '@mui/icons-material/NoAccounts'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import SyncAltIcon from '@mui/icons-material/SyncAlt'
import PaymentsIcon from '@mui/icons-material/Payments'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import SearchIcon from '@mui/icons-material/Search'
import MyLocationIcon from '@mui/icons-material/MyLocation'
import PsychologyIcon from '@mui/icons-material/Psychology'
import TranslateIcon from '@mui/icons-material/Translate'
import { toast } from 'react-toastify'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import CheckIcon from '@mui/icons-material/Check'
import PersonIcon from '@mui/icons-material/Person'
import ClearIcon from '@mui/icons-material/Clear'
import Box from '@mui/material/Box'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import dayjs from 'dayjs'
import api from '@/services/api'
import Notfound from '../../../../Notfound'
import { TableShimmer } from '../../../../ShimmerUI'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Pagination,
  Tooltip,
  TextField,
  InputAdornment,
  Grid,
  Divider,
  Chip,
  Avatar,
  Card,
  CardContent,
  Typography,
  Alert,
  Stack,
  Menu,
  MenuItem,
  Drawer,
  Autocomplete,
  CircularProgress,
  Select,
} from '@mui/material'
import PercentIcon from '@mui/icons-material/Percent'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import RowsPerPageDropdown from '../../RowsPerPageDropdown'
import { ProviderDetailsDialog } from '@/components/provider-details'
import TablePopup from '../../Admin/CommonComponent/TablePopup'
import { Plus } from 'lucide-react'
import { log } from 'console'
import { PendingApprovalReviewDialog } from '@/components/provider-details/PendingApprovalReviewDialog'
import { useGooglePlaces } from '@/hooks/useGooglePlaces'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '@/store'
import { setSelectedAgencyProviderId } from '@/store/slices/appSlice'
import { AreYouSurePopup } from '@/components/Popup'
import { useAuth } from '@/hooks/useAuth'

// API always returns isActive: true; the agency enable/disable toggle is reflected in `status` instead.
const isProviderActive = (provider: any) => provider?.status !== 'inactive'

const AgencyProviderManagement: React.FC = () => {
  const { hasPermission } = useAuth()
  const prevSize = sessionStorage.getItem('prevSize')
  const ourPageSize = prevSize ? parseInt(prevSize, 10) : 10
  const [pageSize, setPageSize] = useState(10)
  const [services, setServices] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [loadingForShimmer, setLoadingForShimmer] = useState(true)
  const [therapists, setTherapists] = useState([])
  const [invitationsList, setInvitationsList] = useState([])
  const [totalInvitations, setTotalInvitations] = useState(0)
  const [pendingApprovalsList, setPendingApprovalsList] = useState<any[]>([])
  const [pendingApprovalsLoading, setPendingApprovalsLoading] = useState(false)
  const [openApprovalReview, setOpenApprovalReview] = useState(false)
  const [selectedApproval, setSelectedApproval] = useState<any>(null)

  const [insuranceSearchTerm, setInsuranceSearchTerm] = useState('')
  const [insuranceOptions, setInsuranceOptions] = useState<any[]>([])
  const [insuranceLoading, setInsuranceLoading] = useState(false)
  const [agencySelectedTherapist, setAgencySelectedTherapist] =
    useState<any>(null)
  const [providerStatusLoading, setProviderStatusLoading] =
    useState<boolean>(false)
  const [openProviderStatusDialog, setOpenProviderStatusDialog] =
    useState<boolean>(false)

  // Fetch insurance options from API (debounced)
  useEffect(() => {
    const trimmed = insuranceSearchTerm.trim()
    if (!trimmed) {
      setInsuranceOptions([])
      return
    }
    setInsuranceLoading(true)
    const handler = setTimeout(() => {
      fetchInsuranceOptions(trimmed)
    }, 400)

    return () => clearTimeout(handler)
  }, [insuranceSearchTerm])

  // const fetchInsuranceOptions = async (search: string) => {
  //   try {
  //     // Updated endpoint as per user instruction
  //     const response = await api.get('/payers/all', { params: { search } })
  //     setInsuranceOptions(response?.data?.data || [])
  //   } catch (error) {
  //     setInsuranceOptions([])
  //   } finally {
  //     setInsuranceLoading(false)
  //   }
  // }
  const fetchInsuranceOptions = async (search: string) => {
    try {
      const response = await api.get('/payers/all', { params: { search } })

      const data = response?.data || []

      setInsuranceOptions(data)
      setShowInsuranceDropdown(data.length > 0)
    } catch (error) {
      setInsuranceOptions([])
      setShowInsuranceDropdown(false)
    } finally {
      setInsuranceLoading(false)
    }
  }

  const [error, setError] = useState('')
  const [searchKeyword, setSearchKeyword] = useState<string>('')
  const [selectedAccountStatus, setSelectedAccountStatus] = useState('')
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [licenseExpiryDate, setLicenseExpiryDate] = useState<Date | null>(null)
  const [selectedInsurance, setSelectedInsurance] = useState<string>('')
  const [selectedSpecialization, setSelectedSpecialization] =
    useState<string>('')
  const [selectedGender, setSelectedGender] = useState<string>('')

  const [totalRecords, setTotalRecords] = useState(0)
  const [totalActiveRecords, setTotalActiveRecords] = useState(0)
  const [totalInactiveRecords, setTotalInactiveRecords] = useState(0)
  const [pendingRecords, setPendingRecords] = useState(0)
  const [onLeaveRecords, setOnLeaveRecords] = useState(0)
  const [openToggle, setOpenToggle] = useState(false) // Dialog open state
  const [sortField, setSortField] = useState<string>('')
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc')
  const [selectedTherapistId, setSelectedTherapistId] = useState<string | null>(
    null
  ) // Selected therapist's ID
  const [isActive, setIsActive] = useState<boolean>(false) // Current status of the therapist
  const [loading, setLoading] = useState<boolean>(false) // Loading state during API request
  const [exportLoading, setExportLoading] = useState<boolean>(false) // Loading state for export
  const [openCommissionDialog, setOpenCommissionDialog] = useState(false) // Commission dialog state
  const [monthlyCommission, setMonthlyCommission] = useState<string>('') // Monthly commission value
  const [yearlyCommission, setYearlyCommission] = useState<string>('') // Yearly commission value
  const [providerFeeDiscountPercent, setProviderFeeDiscountPercent] =
    useState<string>('') // Provider fee discount percentage
  const [commissionLoading, setCommissionLoading] = useState<boolean>(false) // Loading state for commission update
  const [openVerificationDialog, setOpenVerificationDialog] = useState(false) // Verification dialog state
  const [selectedProvider, setSelectedProvider] = useState<any>(null) // Selected provider for verification
  const [approveLoading, setApproveLoading] = useState<boolean>(false) // Loading state for approve action
  const [blockLoading, setBlockLoading] = useState<boolean>(false) // Loading state for block action
  const [openBlockReasonDialog, setOpenBlockReasonDialog] = useState(false) // Block reason dialog state
  const [blockReason, setBlockReason] = useState<string>('') // Block reason text
  const [openProviderDetailsDialog, setOpenProviderDetailsDialog] =
    useState(false) // Provider details (read-only) dialog state
  const [selectedProviderForDetails, setSelectedProviderForDetails] =
    useState<any>(null) // Selected provider for details view
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false)
  const [removeLoading, setRemoveLoading] = useState(false)
  const [openRemoveInvitationConfirm, setOpenRemoveInvitationConfirm] =
    useState(false)
  const [isRemovingInvitation, setIsRemovingInvitation] = useState(false)
  const [openApprovalDrawer, setOpenApprovalDrawer] = useState<boolean>(false) // Open state for pending approvals drawer
  const [selectedApprovalForDrawer, setSelectedApprovalForDrawer] =
    useState<any>(null) // Selected pending approval for review drawer
  const [openReverifyDialog, setOpenReverifyDialog] = useState(false) // Re-verification dialog state
  const [reverifyProviderId, setReverifyProviderId] = useState<string | null>(
    null
  )
  const [reverifyProviderName, setReverifyProviderName] = useState<string>('')
  const [reverifyLoading, setReverifyLoading] = useState<boolean>(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [selectedProviderForDelete, setSelectedProviderForDelete] =
    useState<any>(null)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null)
  const [selectedTherapistForMenu, setSelectedTherapistForMenu] =
    useState<any>(null)

  const [showInsuranceDropdown, setShowInsuranceDropdown] = useState(false)

  // Specialization Search States
  const [specializationSearchTerm, setSpecializationSearchTerm] = useState('')

  const [specializationOptions, setSpecializationOptions] = useState<any[]>([])

  const [specializationLoading, setSpecializationLoading] = useState(false)

  const [showSpecializationDropdown, setShowSpecializationDropdown] =
    useState(false)

  const [isSelectingSpecialization, setIsSelectingSpecialization] =
    useState(false)

  const specializationDropdownRef = useRef<any>(null)

  const [location, setLocation] = useState<string | null>('')

  const [locationPredictions, setLocationPredictions] = useState<any[]>([])

  const [locationSearchTerm, setLocationSearchTerm] = useState('')

  const [locationLoading, setLocationLoading] = useState(false)
  const [selectedLocationData, setSelectedLocationData] = useState<any>(null)

  const {
    isLoaded: isPlacesLoaded,
    isLoading: isPlacesLoading,
    autocompleteService,
  } = useGooglePlaces()

  useEffect(() => {
    if (
      !autocompleteService ||
      !locationSearchTerm ||
      !locationSearchTerm.trim()
    ) {
      setLocationPredictions([])
      return
    }

    setLocationLoading(true)

    autocompleteService.getPlacePredictions(
      {
        input: locationSearchTerm,
        types: ['geocode'],
      },
      (predictions, status) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          predictions
        ) {
          setLocationPredictions(predictions)
        } else {
          setLocationPredictions([])
        }

        setLocationLoading(false)
      }
    )
  }, [autocompleteService, locationSearchTerm])
  const handleLocationInputChange = (value: string) => {
    setLocationSearchTerm(value)
  }

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        specializationDropdownRef.current &&
        !specializationDropdownRef.current.contains(event.target)
      ) {
        setShowSpecializationDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const fetchSpecializationOptions = async (search: string) => {
    try {
      setSpecializationLoading(true)

      const response = await api.get('/specilities/specility', {
        params: { search },
      })

      const data = response?.data?.data || response?.data || []

      setSpecializationOptions(data)
    } catch (error) {
      console.error('Error fetching specialization:', error)

      setSpecializationOptions([])
    } finally {
      setSpecializationLoading(false)
    }
  }
  useEffect(() => {
    if (isSelectingSpecialization) return

    const handler = setTimeout(() => {
      fetchSpecializationOptions(specializationSearchTerm)
    }, 400)

    return () => clearTimeout(handler)
  }, [specializationSearchTerm, isSelectingSpecialization])

  const handleOpenMenu = (
    event: React.MouseEvent<HTMLButtonElement>,
    therapist: any
  ) => {
    setMenuAnchorEl(event.currentTarget)
    setSelectedTherapistForMenu(therapist)
  }

  const handleCloseMenu = () => {
    setMenuAnchorEl(null)
    setSelectedTherapistForMenu(null)
  }

  const handleRemoveInvitation = async (providerId: string) => {
    if (!providerId) return
    try {
      const response = await api.patch(
        `/provider-invitations/${providerId}/revoke`
      )
      toast.success(
        response?.data?.message || 'Invitation revoked successfully'
      )

      if (activeTab === 'invitations') {
        fetchInvitations(currentPage)
      }
    } catch (error: any) {
      console.error('Error removing invitation:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to remove invitation'
      )
    }
  }

  const handleOpenProviderStatusDialog = (therapist: any) => {
    if (!therapist?._id) return
    setAgencySelectedTherapist(therapist)
    setOpenProviderStatusDialog(true)
    handleCloseMenu()
  }

  const handleConfirmProviderStatus = async () => {
    if (!agencySelectedTherapist?._id) return
    setProviderStatusLoading(true)

    const newStatus = !isProviderActive(agencySelectedTherapist)
    try {
      const response = await api.patch(
        `/agency-provider/provider/${agencySelectedTherapist._id}/status`,
        { isActive: newStatus }
      )

      toast.success(
        response?.data?.message ||
          `Provider ${newStatus ? 'enabled' : 'disabled'} successfully`
      )

      // Optimistically update local state so the menu/dialog reflect the new status immediately
      const newProviderStatus = newStatus ? 'active' : 'inactive'
      setTherapists((prev: any[]) =>
        prev.map(t =>
          t._id === agencySelectedTherapist._id
            ? { ...t, status: newProviderStatus }
            : t
        )
      )
      setAgencySelectedTherapist((prev: any) =>
        prev ? { ...prev, status: newProviderStatus } : prev
      )

      if (activeTab === 'active') {
        fetchTherapists(currentPage, true)
      } else {
        fetchTherapists(currentPage)
      }
      setOpenProviderStatusDialog(false)
    } catch (error: any) {
      console.error('Error updating provider status:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to update provider status'
      )
    } finally {
      setProviderStatusLoading(false)
    }
  }

  const handleOpenApprovalReview = (approval: any) => {
    // console.log("approval------------------------------------------------", approval)
    setSelectedApproval(approval)
    setOpenApprovalReview(true)
  }

  const handleCloseApprovalReview = () => {
    setOpenApprovalReview(false)
    setSelectedApproval(null)
  }
  const [commissionData, setCommissionData] = useState<any>(null)
  const [enrollmentStatus, setEnrollmentStatus] = useState<string>('')
  const [openTablePopup, setOpenTablePopup] = useState(false)
  const [tableData, setTableData] = useState<any>(null)
  const [tableTitle, setTableTitle] = useState<string>('')
  const [activeTab, setActiveTab] = useState<string>('all')

  // Invite Provider State
  const [openInviteDialog, setOpenInviteDialog] = useState(false)
  const [inviteName, setInviteName] = useState('')
  const [inviteEmail, setInviteEmail] = useState('')
  const [inviteLoading, setInviteLoading] = useState(false)
  const navigate = useNavigate()

  const handleViewProfile = (providerId: string) => {
    // Navigate to the provider's profile page
    navigate(`/agency-therapists-details/${providerId}`)
  }
  const handleViewPayOutSettings = (id: string) => {
    navigate(`/agency-payout-settings/${id}`)
  }

  const handleOpenInviteDialog = () => {
    setInviteName('')
    setInviteEmail('')
    setOpenInviteDialog(true)
  }

  const handleCloseInviteDialog = () => {
    setOpenInviteDialog(false)
    setInviteName('')
    setInviteEmail('')
  }

  const handleInviteProvider = async () => {
    if (!inviteName.trim() || !inviteEmail.trim()) {
      toast.error('Please enter both name and email')
      return
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(inviteEmail)) {
      toast.error('Please enter a valid email address')
      return
    }

    setInviteLoading(true)
    try {
      const response = await api.post('provider-invitations/invite', {
        providerName: inviteName.trim(),
        providerEmail: inviteEmail.trim(),
      })

      if (response.status === 200 || response.status === 201) {
        toast.success('Invitation sent successfully')
        handleCloseInviteDialog()
        fetchInvitations(1)
      }
    } catch (error: any) {
      console.error('Error inviting provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to send invitation')
    } finally {
      setInviteLoading(false)
    }
  }

  const handleEnrollmentStatusChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setEnrollmentStatus(e.target.value)
  }
  //finalperclaimfee show only two decimal point
  const finalperclaimfee =
    Number(monthlyCommission) - Number(providerFeeDiscountPercent)
  const finalperclaimfeeDisplay = finalperclaimfee.toFixed(2)
  const handleExport = async () => {
    setExportLoading(true)
    try {
      const params: Record<string, any> = {
        accountStatus:
          selectedAccountStatus === 'Active'
            ? true
            : selectedAccountStatus === 'Inactive'
              ? false
              : undefined,
      }

      // If search keyword exists, add it to params
      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }

      if (startDate) {
        params.startDate = getFormattedDateForAPI(startDate)
      }

      if (endDate) {
        params.endDate = getFormattedDateForAPI(endDate)
      }

      if (licenseExpiryDate) {
        params.expiry = getFormattedDateForAPI(licenseExpiryDate)
      }

      const response = await api.get('agency-provider/therapists/export', {
        responseType: 'blob',
        params,
      })

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: String(response.headers['content-type'] || 'text/csv'),
      })

      // Create a download link
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url

      // Get filename from Content-Disposition header or use default
      // const contentDisposition = response.headers['content-disposition']
      let filename = 'providers_export.csv'
      // if (contentDisposition) {
      //   const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i)
      //   if (filenameMatch) {
      //     filename = filenameMatch[1]
      //   }
      // }

      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      toast.success('Export completed successfully')
    } catch (error) {
      console.error('Error exporting providers:', error)
      toast.error('Failed to export providers data')
    } finally {
      setExportLoading(false)
    }
  }

  const getCommonParams = (page?: number) => {
    const params: Record<string, any> = {
      page: page || 1,
      limit: pageSize,
    }

    if (location) {
      params.location = location
    }

    if (selectedInsurance) {
      params.insurance = selectedInsurance
    }

    if (selectedSpecialization) {
      params.specialization = selectedSpecialization
    }

    if (selectedGender) {
      params.gender = selectedGender.toLowerCase()
    }

    if (searchKeyword?.trim()) {
      params.search = searchKeyword
    }

    if (enrollmentStatus) {
      params.enrollmentStatus = enrollmentStatus
    }

    if (startDate) {
      params.startDate = getFormattedDateForAPI(startDate)
    }

    if (endDate) {
      params.endDate = getFormattedDateForAPI(endDate)
    }

    if (licenseExpiryDate) {
      params.expiry = getFormattedDateForAPI(licenseExpiryDate)
    }

    if (sortField) {
      params.sortField = sortField
      params.sortOrder = sortOrder
    }

    return params
  }

  const getFormattedDateForAPI = (date: Date | null): string | null => {
    if (!date) return null

    const year = date.getFullYear()
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)

    return `${year}-${month}-${day}` // YYYY-MM-DD format
  }
  const handleAccountStatusChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedAccountStatus(event.target.value)
  }

  const handleOpenToggle = (providerId: string, currentStatus: boolean) => {
    setSelectedTherapistId(providerId) // Set the selected therapist to toggle
    setIsActive(currentStatus) // Set the current status of the therapist (active or inactive)
    setOpenToggle(true) // Open the confirmation dialog
  }

  const handleConfirmToggle = async () => {
    if (!selectedTherapistId) return // Exit if no therapist is selected
    setLoading(true) // Start loading

    const newStatus = !isActive // Toggle the status
    try {
      const response = await api.patch(
        `/admin/therapist/${selectedTherapistId}/status`,
        { isActive: newStatus }
      )

      if (response.status === 200) {
        setIsActive(newStatus) // Toggle status locally
        toast.success(
          `Provider status updated to ${newStatus ? 'Active' : 'Inactive'}`
        )
      }

      setOpenToggle(false) // Close the dialog after success
      fetchTherapists() // Optionally refresh the therapist list
    } catch (error) {
      console.error('Error updating the provider status:', error)
      toast.error('Failed to update provider status')
    } finally {
      setLoading(false) // Stop loading
    }
  }

  const handleOpenDeleteDialog = (therapist: any) => {
    setSelectedProviderForDelete(therapist)
    setOpenDeleteDialog(true)
  }

  const handleCloseDeleteDialog = () => {
    if (!deleteLoading) {
      setOpenDeleteDialog(false)
      setSelectedProviderForDelete(null)
    }
  }

  const handleConfirmDelete = async () => {
    if (!selectedProviderForDelete?._id) return

    setDeleteLoading(true)
    try {
      await api.delete(`admin/provider/${selectedProviderForDelete._id}`)
      toast.success('Provider deleted successfully')
      handleCloseDeleteDialog()
      fetchTherapists(currentPage)
    } catch (error: any) {
      console.error('Error deleting provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to delete provider')
    } finally {
      setDeleteLoading(false)
    }
  }

  const handleOpenCommissionDialog = (therapist: any) => {
    setSelectedTherapistId(therapist._id)
    setMonthlyCommission(therapist.commission?.toString() || '')
    setProviderFeeDiscountPercent(
      therapist.providerFeeDiscountPercent?.toString() || ''
    )
    setCommissionData(therapist)

    console.log('commissionData', therapist)
    setOpenCommissionDialog(true)
  }

  const handleCloseCommissionDialog = () => {
    setOpenCommissionDialog(false)
    setSelectedTherapistId(null)
    setMonthlyCommission('')
    setYearlyCommission('')
    setProviderFeeDiscountPercent('')
    setCommissionData(null)
  }

  const handleUpdateCommission = async () => {
    if (!selectedTherapistId) return

    // Validate inputs
    if (!monthlyCommission.trim()) {
      toast.error('Please enter both monthly and yearly commission values')
      return
    }
    if (finalperclaimfee <= 0) {
      toast.error(
        'The entered percentages result in a platform fee of 0 or less. Please update the values to maintain a minimum positive fee.'
      )
      return
    }

    const commission = parseFloat(monthlyCommission)
    const discountValue = providerFeeDiscountPercent.trim()
      ? parseFloat(providerFeeDiscountPercent)
      : 0

    if (isNaN(commission) || commission < 0) {
      toast.error('Please enter valid commission values (numbers >= 0)')
      return
    }

    if (
      providerFeeDiscountPercent.trim() &&
      (isNaN(discountValue) || discountValue < 0 || discountValue > 100)
    ) {
      toast.error('Please enter a valid discount percentage (0-100)')
      return
    }

    setCommissionLoading(true)
    try {
      const response = await api.patch(
        `/admin/therapist/${selectedTherapistId}/commission`,
        {
          commission: commission,
          providerFeeDiscountPercent: discountValue,
        }
      )

      if (response.status === 200) {
        toast.success('Commission updated successfully')
        handleCloseCommissionDialog()
      }
    } catch (error: any) {
      console.error('Error updating commission:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to update commission'
      )
    } finally {
      setCommissionLoading(false)
    }
  }

  const handleOpenVerificationDialog = (therapist: any) => {
    setSelectedProvider(therapist)
    setOpenVerificationDialog(true)
  }

  const handleCloseVerificationDialog = () => {
    setOpenVerificationDialog(false)
    setSelectedProvider(null)
  }

  const handleOpenProviderDetailsDialog = (therapist: any) => {
    setSelectedProviderForDetails(therapist)
    setOpenProviderDetailsDialog(true)
  }

  const handleCloseProviderDetailsDialog = () => {
    setOpenProviderDetailsDialog(false)
    setSelectedProviderForDetails(null)
  }

  const handleApproveTherapist = async () => {
    if (!selectedProvider?._id) return

    setApproveLoading(true)
    try {
      const response = await api.post(
        `/therapist/${selectedProvider._id}/approve`
      )

      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message)
        handleCloseVerificationDialog()
        fetchTherapists() // Refresh the therapist list
      }
    } catch (error: any) {
      console.error('Error approving provider:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to approve provider'
      )
    } finally {
      setApproveLoading(false)
    }
  }

  const handleOpenBlockReasonDialog = () => {
    setBlockReason('')
    setOpenBlockReasonDialog(true)
  }

  const handleCloseBlockReasonDialog = () => {
    setOpenBlockReasonDialog(false)
    setBlockReason('')
  }

  const handleConfirmBlock = async () => {
    if (!selectedProvider?._id) return

    if (!blockReason.trim()) {
      toast.error('Please provide a reason for blocking the provider')
      return
    }

    setBlockLoading(true)
    try {
      const response = await api.post(
        `/therapist/${selectedProvider._id}/block`,
        {
          reason: blockReason.trim(),
        }
      )

      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message)
        handleCloseBlockReasonDialog()
        handleCloseVerificationDialog()
        fetchTherapists() // Refresh the therapist list
      }
    } catch (error: any) {
      console.error('Error blocking provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to block provider')
    } finally {
      setBlockLoading(false)
    }
  }

  const handleOpenReverifyDialog = (therapist: any) => {
    setReverifyProviderId(therapist?._id || null)
    setReverifyProviderName(
      therapist
        ? `${therapist?.firstName || ''} ${therapist?.lastName || ''}`.trim()
        : ''
    )
    setOpenReverifyDialog(true)
  }

  const handleCloseReverifyDialog = () => {
    setOpenReverifyDialog(false)
    setReverifyProviderId(null)
    setReverifyProviderName('')
  }

  const handleReverifyProvider = async () => {
    if (!reverifyProviderId) return

    setReverifyLoading(true)

    try {
      const response = await api.get(
        `/agreements/signed/therapist-verification/${reverifyProviderId}`
      )

      const message =
        response?.data?.message ||
        'Provider re-verification request completed successfully'

      toast.success(message)

      // Refresh the therapist list to reflect any potential changes
      fetchTherapists(currentPage)
    } catch (error: any) {
      console.error('Error during provider re-verification:', error)

      const message =
        error?.response?.data?.message || 'Failed to re-verify provider'

      toast.error(message)
    } finally {
      setReverifyLoading(false)
      handleCloseReverifyDialog()
    }
  }

  const formatDateMMDDYY = (date: string | Date | null | undefined) => {
    if (!date) return '--'
    const dayjsDate = dayjs(date)
    if (!dayjsDate.isValid()) return '--'
    return dayjsDate.format('MM/DD/YYYY')
  }
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page)
    fetchTherapists(page)
  }

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize)
    sessionStorage.setItem('prevSize', newPageSize.toString())
  }
  const fetchTherapists = async (page?: number, onlyActive?: boolean) => {
    setLoading(true)
    setError('')
    try {
      setLoadingForShimmer(true)
      const params = getCommonParams(page)
      if (onlyActive) {
        params.accountStatus = true
      }

      if (selectedInsurance) {
        params.insurance = selectedInsurance
      }

      if (selectedSpecialization) {
        params.specialization = selectedSpecialization
      }

      if (selectedGender) {
        params.gender = selectedGender.toLowerCase()
      }
      if (location) {
        params.location = location
      }

      // If search keyword exists, add it to params
      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }

      if (enrollmentStatus) {
        params.enrollmentStatus = enrollmentStatus
      }

      if (startDate) {
        params.startDate = getFormattedDateForAPI(startDate)
      }

      if (endDate) {
        params.endDate = getFormattedDateForAPI(endDate)
      }

      if (licenseExpiryDate) {
        params.expiry = getFormattedDateForAPI(licenseExpiryDate)
      }

      // Add sorting parameters
      if (sortField) {
        params.sortField = sortField
        params.sortOrder = sortOrder
      }

      // Make the API call with params
      console.log('Fetching therapists with params:', params)
      const response = await api.get('agency-provider/therapists', {
        params,
      })
      console.log('API Response received:', response?.data)

      // Check if data exists and set the therapists state
      if (response?.data?.data) {
        setTherapists(response.data.data)
      } else {
        setError('No providers data found')
      }
      setTotalRecords(response?.data?.stats?.totalTherapists || 0)
      setTotalActiveRecords(response?.data?.stats?.totalActiveTherapists || 0)
      setTotalInactiveRecords(
        response?.data?.stats?.totalInactiveTherapists || 0
      )
      setOnLeaveRecords(response?.data?.stats?.onLeave || 0)
      setTotalPages(Math.ceil(response?.data?.totalRecords / pageSize) || 1)
    } catch (err: any) {
      console.error('Error fetching providers:', err?.response?.data || err)
      setError('Failed to fetch providers')
    } finally {
      setLoadingForShimmer(false)
      setLoading(false)
    }
  }

  // Location search effects removed in favor of direct state change query binding
  const fetchInvitations = async (page?: number) => {
    setLoading(true)
    setError('')
    try {
      setLoadingForShimmer(true)
      const params: Record<string, any> = {
        page: page || 1,
        limit: pageSize,
      }
      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }
      const response = await api.get('provider-invitations/agency', {
        params,
      })
      // API returns a plain array directly
      const list = Array.isArray(response?.data)
        ? response.data
        : response?.data?.data || []
      setInvitationsList(list)
      const total = Array.isArray(response?.data)
        ? response.data.length
        : response?.data?.totalRecords || 0
      setTotalInvitations(total)
      if (activeTab === 'invitations') {
        setTotalPages(Math.ceil(total / pageSize) || 1)
      }
    } catch (err: any) {
      console.error('Error fetching invitations:', err)
      setError('Failed to fetch invitations')
    } finally {
      setLoadingForShimmer(false)
      setLoading(false)
    }
  }

  const fetchPendingApprovals = async () => {
    setPendingApprovalsLoading(true)
    try {
      const params = getCommonParams(currentPage)

      const response = await api.get('agency/provider-approvals/pending', {
        params,
      })
      const rawData = response?.data?.data
      let list = []
      let totalCount = 0

      if (Array.isArray(rawData)) {
        list = rawData
        totalCount = rawData.length
      } else if (rawData && typeof rawData === 'object') {
        if (Array.isArray(rawData.data)) {
          list = rawData.data
          totalCount =
            typeof rawData.totalRecords === 'number'
              ? rawData.totalRecords
              : rawData.data.length
        } else {
          list = []
          totalCount = 0
        }
      }

      setPendingApprovalsList(list)
      setPendingRecords(totalCount)
    } catch (err: any) {
      console.error('Error fetching pending approvals:', err)
    } finally {
      setPendingApprovalsLoading(false)
    }
  }

  const handleApproveProvider = async (approvalId: string) => {
    try {
      const response = await api.put(
        `agency/provider-approvals/${approvalId}/approve`
      )
      if (response.status === 200 || response.status === 201) {
        toast.success(
          response?.data?.message || 'Provider approved successfully'
        )
        fetchPendingApprovals()
      }
    } catch (error: any) {
      console.error('Error approving provider:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to approve provider'
      )
    }
  }

  const handleRejectProvider = async (approvalId: string) => {
    try {
      const response = await api.put(
        `agency/provider-approvals/${approvalId}/reject`
      )
      if (response.status === 200 || response.status === 201) {
        toast.success(
          response?.data?.message || 'Provider rejected successfully'
        )
        fetchPendingApprovals()
      }
    } catch (error: any) {
      console.error('Error rejecting provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to reject provider')
    }
  }

  const handleReset = () => {
    setSearchKeyword('')
    setSelectedAccountStatus('')
    setStartDate(null)
    setEndDate(null)
    setLicenseExpiryDate(null)
    setSortField('')
    setSortOrder('asc')
    setEnrollmentStatus('')
    setLocation('')
    setSelectedLocationData(null)
    setInsuranceSearchTerm('')
    setSelectedInsurance('')
    setSpecializationSearchTerm('')
    setSelectedSpecialization('')
    setSelectedGender('')
    setCurrentPage(1)
  }

  const handleSort = (field: string) => {
    if (sortField === field) {
      // Toggle sort order if same field
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    } else {
      // Set new field and default to ascending
      setSortField(field)
      setSortOrder('asc')
    }
  }

  const getSortIcon = (field: string) => {
    if (sortField !== field) {
      return <UnfoldMoreIcon className="w-4 h-4 ml-1" />
    }
    return sortOrder === 'asc' ? (
      <KeyboardArrowUpIcon className="w-4 h-4 ml-1" />
    ) : (
      <KeyboardArrowDownIcon className="w-4 h-4 ml-1" />
    )
  }
  // const handleOpenToggle = async (
  //   providerId: string,
  //   currentStatus: boolean
  // ) => {
  //   try {
  //     // Toggle the status (flip the boolean value of isActive)
  //     const newStatus = !currentStatus

  //     // Call the API to update the therapist's status
  //     const response = await api.patch(
  //       `/admin/therapist/${providerId}/status`,
  //       {
  //         isActive: newStatus,
  //       }
  //     )

  //     if (response.status === 200) {
  //       // On success, toggle the status locally
  //       setIsActive(newStatus) // Update the state to reflect the new status
  //       toast.success(
  //         `Therapist status updated to ${newStatus ? 'Active' : 'Inactive'}`
  //       )
  //     }

  //     // Optionally, refresh the list of therapists
  //     fetchTherapists()
  //   } catch (error) {
  //     console.error('Error updating the therapist status:', error)
  //     toast.error('Failed to update therapist status')
  //   }
  // }

  // useEffect(() => {
  //   const trimmed = insuranceSearchTerm.trim()
  //   if (!trimmed) {
  //     setInsuranceOptions([])
  //     return
  //   }
  //   const handler = setTimeout(() => {
  //     fetchInsuranceOptions(trimmed)
  //   }, 400)

  //   return () => clearTimeout(handler)
  // }, [insuranceSearchTerm])

  useEffect(() => {
    // Initial fetch to get the count for the cards
    fetchInvitations(1)
    fetchPendingApprovals()
  }, [])

  useEffect(() => {
    if (activeTab === 'invitations') {
      fetchInvitations(currentPage)
    } else if (activeTab === 'pending') {
      fetchPendingApprovals()
    } else if (activeTab === 'active') {
      fetchTherapists(currentPage, true)
    } else {
      fetchTherapists(currentPage)
    }
  }, [
    searchKeyword,
    selectedAccountStatus,
    startDate,
    endDate,
    licenseExpiryDate,
    sortField,
    sortOrder,
    pageSize,
    currentPage,
    enrollmentStatus,
    activeTab,
    selectedInsurance,
    selectedSpecialization,
    selectedGender,
    location,
  ])

  const insuranceRef = useRef<HTMLDivElement>(null)

  // Add this effect in your component
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        insuranceRef.current &&
        !insuranceRef.current.contains(e.target as Node)
      ) {
        setShowInsuranceDropdown(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleRemoveProvider = async () => {
    if (!agencySelectedTherapist?._id) return

    setRemoveLoading(true)
    try {
      const response = await api.delete(
        `agency-provider/${agencySelectedTherapist._id}/remove`
      )
      toast.success(response?.data?.message || 'Provider removed successfully')
      setOpenRemoveDialog(false)
      fetchTherapists() // Refresh the list
    } catch (error: any) {
      console.error('Error removing provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to remove provider')
    } finally {
      setRemoveLoading(false)
    }
  }

  const dispatch = useAppDispatch()
  const handleNavigatePackageManagement = (id: string) => {
    dispatch(setSelectedAgencyProviderId(id))
    navigate(`/agency-provider-service-packages/${id}`)
  }
  return (
    <div className="p-6 mx-auto max-w-7xl">
      {/* Header & Filters */}
      {/* Header */}
      <div className="flex flex-col items-start justify-between gap-4 mb-4 sm:flex-row sm:items-center">
        <div className="flex flex-col items-start gap-1">
          <h1 className="text-2xl font-bold text-[#4B3E7C]">Providers</h1>
          <span className="text-sm font-medium text-gray-500">
            Manage and monitor your agency's healthcare providers.
          </span>
        </div>

        <div className="flex items-center gap-3">
          <button
            className="flex items-center gap-2 px-4 py-2 text-[#4B3E7C] bg-white border border-[#A0AEC0] rounded-lg hover:bg-gray-50 disabled:opacity-50 text-sm font-medium"
            onClick={handleExport}
            disabled={exportLoading}
            style={{
              cursor: exportLoading ? 'not-allowed' : 'pointer',
            }}
          >
            <FiDownload className="w-4 h-4" />
            {exportLoading ? 'Exporting...' : 'Export CSV'}
          </button>
          {hasPermission('provider.create') && (
            <button
              className="flex items-center gap-2 px-4 py-2 text-white bg-[#7A6FA1] border border-transparent rounded-lg hover:bg-[#6c6191] disabled:opacity-50 text-sm font-medium shadow-sm"
              disabled={exportLoading}
              style={{ cursor: 'pointer' }}
              onClick={handleOpenInviteDialog}
            >
              <Plus className="w-4 h-4" />
              Invite Provider
            </button>
          )}
        </div>
      </div>

      {/* Provider Tabs as Cards */}
      <div className="grid grid-cols-1 gap-4 mb-6 sm:grid-cols-5">
        {[
          { key: 'all', label: 'Total Providers', count: totalRecords },
          { key: 'active', label: 'Active', count: totalActiveRecords },
          { key: 'pending', label: 'Provider Request', count: pendingRecords },
          { key: 'onleave', label: 'On Leave', count: onLeaveRecords },
          {
            key: 'invitations',
            label: 'Providers Invitations',
            count: totalInvitations,
          },
        ].map(tab => (
          <div
            key={tab.key}
            onClick={() => {
              if (tab.key === 'onleave') return
              setActiveTab(tab.key)
              setCurrentPage(1)
            }}
            className={`flex flex-col justify-between p-4 bg-white rounded-xl transition-all duration-200 ${
              tab.key === 'onleave'
                ? 'cursor-default border border-gray-100 shadow-sm opacity-80'
                : `cursor-pointer ${
                    activeTab === tab.key
                      ? 'border-[3px] border-[#7A6FA1] shadow-sm'
                      : 'border border-gray-100 shadow-sm hover:border-gray-200 hover:shadow-md'
                  }`
            }`}
          >
            <div className="flex justify-between items-start">
              <h2
                className={`text-[28px] leading-none font-bold ${activeTab === tab.key ? 'text-[#4B3E7C]' : 'text-[#7A6FA1]'}`}
              >
                {tab.count}
              </h2>
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-[#f3f0ff]">
                <PersonIcon sx={{ fontSize: 16, color: '#7A6FA1' }} />
              </div>
            </div>
            <p
              className={`text-[13px] font-medium mt-3 ${activeTab === tab.key ? 'text-gray-800' : 'text-gray-500'}`}
            >
              {tab.label}
            </p>
          </div>
        ))}
      </div>

      <div className="flex flex-col md:flex-row gap-4 mb-6">
        <div className="w-full md:w-[280px]">
          <label className="block mb-2 text-[13px] font-medium text-[#7A6FA1]">
            Search Provider
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <SearchIcon sx={{ fontSize: 18, color: '#A0AEC0' }} />
            </div>
            <input
              type="text"
              placeholder="Search providers by name"
              value={searchKeyword}
              onChange={e => setSearchKeyword(e.target.value)}
              className="w-full pl-10 pr-3 py-[11px] bg-gray-50/50 border border-gray-200 rounded-xl text-[13px] focus:outline-none focus:ring-2 focus:ring-[#7A6FA1] focus:border-transparent"
            />
          </div>
        </div>

        {activeTab === 'invitations' || activeTab === 'pending' ? null : (
          <div className="flex-1">
            <label className="block mb-2 text-[13px] font-medium text-[#7A6FA1]">
              Filters
            </label>
            <div className="flex items-center w-full bg-white border border-gray-200 rounded-xl px-1 py-1 h-[44px]">
              <div className="flex items-center flex-1 px-3 border-r border-gray-200 h-full">
                <LocationOn
                  sx={{
                    color: '#7A6FA1',
                    fontSize: 16,
                  }}
                  className="mr-2"
                />
                <div className="w-full relative">
                  <input
                    type="text"
                    value={location || ''}
                    onChange={e => {
                      setLocation(e.target.value)
                    }}
                    placeholder="Search location.."
                    className="w-full text-[13px] text-gray-500 bg-transparent focus:outline-none font-medium"
                    autoComplete="off"
                  />
                  {location && (
                    <button
                      type="button"
                      className="absolute right-2 top-0.5 text-xs text-gray-400 hover:text-gray-600"
                      onClick={() => {
                        setLocation('')
                      }}
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>

              <div className="flex items-center flex-1 px-3 border-r border-gray-200 h-full">
                <HealthAndSafetyIcon
                  sx={{ fontSize: 16, color: '#7A6FA1' }}
                  className="mr-2"
                />
                <div className="w-full relative" ref={insuranceRef}>
                  <input
                    type="text"
                    value={insuranceSearchTerm}
                    onChange={e => {
                      setInsuranceSearchTerm(e.target.value)
                      setSelectedInsurance('')
                      setShowInsuranceDropdown(true)
                    }}
                    onFocus={() => {
                      if (insuranceOptions.length > 0)
                        setShowInsuranceDropdown(true)
                    }}
                    placeholder="Search Insurance.."
                    className="w-full text-[13px] text-gray-500 bg-transparent focus:outline-none font-medium pr-6"
                    autoComplete="off"
                  />

                  {insuranceLoading && (
                    <span className="absolute right-2 top-2 text-xs text-gray-400">
                      Loading...
                    </span>
                  )}

                  {/* ✅ Only controlled by showInsuranceDropdown now */}
                  {showInsuranceDropdown && (
                    <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 rounded shadow mt-1 max-h-40 overflow-y-auto">
                      {insuranceOptions.length === 0 ? (
                        <li className="px-3 py-2 text-[13px] text-gray-400">
                          No results found
                        </li>
                      ) : (
                        insuranceOptions.map((option: any) => (
                          <li
                            key={option._id}
                            className="px-3 py-2 text-[13px] text-gray-700 hover:bg-[#f3f0ff] cursor-pointer"
                            onMouseDown={() => {
                              setSelectedInsurance(option._id)
                              setInsuranceSearchTerm(option.payer_name)
                              setInsuranceOptions([])
                              setShowInsuranceDropdown(false)
                            }}
                          >
                            {option?.payer_name}
                          </li>
                        ))
                      )}
                    </ul>
                  )}

                  {insuranceSearchTerm && (
                    <button
                      type="button"
                      className="absolute right-0 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-base leading-none"
                      onClick={() => {
                        setInsuranceSearchTerm('')
                        setSelectedInsurance('')
                        setShowInsuranceDropdown(false) // ✅ also close on clear
                      }}
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>

              <div
                ref={specializationDropdownRef}
                className="relative flex items-center flex-1 px-3 border-r border-gray-200 h-full"
              >
                <PsychologyIcon
                  sx={{ fontSize: 16, color: '#7A6FA1' }}
                  className="mr-2"
                />

                <input
                  type="text"
                  placeholder="Select Specialization.."
                  value={specializationSearchTerm}
                  onChange={e => {
                    setSpecializationSearchTerm(e.target.value)
                    setShowSpecializationDropdown(true)
                  }}
                  onFocus={() => {
                    if (!showSpecializationDropdown) {
                      setShowSpecializationDropdown(true)

                      if (specializationOptions.length === 0) {
                        fetchSpecializationOptions('')
                      }
                    }
                  }}
                  className="w-full text-[13px] text-gray-500 bg-transparent focus:outline-none placeholder-gray-400"
                />
                <div className="absolute right-2 flex items-center gap-2">
                  {specializationLoading && (
                    <span className="text-[11px] text-[#7A6FA1]">
                      Loading...
                    </span>
                  )}

                  {specializationSearchTerm && (
                    <button
                      type="button"
                      onClick={() => {
                        setIsSelectingSpecialization(true)

                        setSpecializationSearchTerm('')
                        setSelectedSpecialization('')
                        setShowSpecializationDropdown(false)

                        setTimeout(() => {
                          setIsSelectingSpecialization(false)
                        }, 200)
                      }}
                      className="flex items-center justify-center w-5 h-5 text-gray-400 rounded-full hover:bg-gray-100 hover:text-gray-600 transition-all"
                    >
                      ×
                    </button>
                  )}
                </div>

                {showSpecializationDropdown && (
                  <div className="absolute left-0 right-0 top-[48px] z-50 bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden">
                    <div className="max-h-[220px] overflow-y-auto">
                      {specializationOptions.length > 0 ? (
                        specializationOptions.map((item: any) => (
                          <div
                            key={item._id}
                            onMouseDown={() => {
                              setIsSelectingSpecialization(true)

                              setSelectedSpecialization(item._id)

                              setSpecializationSearchTerm(
                                item.name || item.label || ''
                              )

                              setShowSpecializationDropdown(false)

                              setTimeout(() => {
                                setIsSelectingSpecialization(false)
                              }, 200)
                            }}
                            className="px-4 py-3 text-[13px] text-gray-700 cursor-pointer hover:bg-[#f3f0ff] border-b border-gray-100 last:border-b-0 transition-all duration-150"
                          >
                            {item.name}
                          </div>
                        ))
                      ) : (
                        <div className="px-4 py-3 text-[13px] text-gray-400">
                          No specialization found
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              {/* <div className="flex items-center flex-1 px-3 border-r border-gray-200 h-full">
              <TranslateIcon sx={{ fontSize: 16, color: '#7A6FA1' }} className="mr-2" />
              <select className="w-full text-[13px] text-gray-400 bg-transparent focus:outline-none appearance-none cursor-pointer">
                <option>Select Language</option>
              </select>
              <KeyboardArrowDownIcon sx={{ fontSize: 16, color: '#A0AEC0' }} />
            </div> */}
              <div className="relative flex items-center flex-1 px-3 h-full">
                <PersonOutlineIcon
                  sx={{ fontSize: 16, color: '#7A6FA1' }}
                  className="mr-2"
                />

                <Select
                  value={selectedGender}
                  onChange={e => setSelectedGender(e.target.value as string)}
                  displayEmpty
                  variant="standard"
                  disableUnderline
                  IconComponent={() => null}
                  sx={{
                    width: '100%',
                    fontSize: '13px',
                    color: selectedGender ? '#1E1743' : '#8A82A5',
                    fontWeight: 500,
                    cursor: 'pointer',
                    '& .MuiSelect-select': {
                      py: 0,
                      pr: '24px',
                      backgroundColor: 'transparent',
                      '&:focus': {
                        backgroundColor: 'transparent',
                      },
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        borderRadius: '12px',
                        boxShadow: '0 8px 24px rgba(122, 111, 161, 0.15)',
                        border: '1px solid #e8e4f3',
                        mt: 1.5,
                        '& .MuiMenuItem-root': {
                          fontSize: '13px',
                          color: '#1E1743',
                          fontWeight: 500,
                          py: 1.2,
                          px: 2,
                          '&:hover': {
                            backgroundColor: '#f3f0ff',
                            color: '#7A6FA1',
                          },
                          '&.Mui-selected': {
                            backgroundColor: '#ede9f8',
                            color: '#4B3E7C',
                            fontWeight: 600,
                            '&:hover': {
                              backgroundColor: '#e6e1f6',
                            },
                          },
                        },
                      },
                    },
                  }}
                >
                  <MenuItem value="" disabled>
                    <span style={{ color: '#8A82A5' }}>Select Gender</span>
                  </MenuItem>
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                  <MenuItem value="Prefer not to say">Prefer not to say</MenuItem>
                </Select>

                <div className="absolute right-2 flex items-center gap-1 pointer-events-none">
                  {selectedGender && (
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedGender('');
                      }}
                      className="flex items-center justify-center w-5 h-5 text-gray-400 rounded-full hover:bg-gray-100 hover:text-gray-600 transition-all pointer-events-auto"
                    >
                      ×
                    </button>
                  )}

                  <KeyboardArrowDownIcon
                    sx={{ fontSize: 16, color: '#A0AEC0' }}
                  />
                </div>
              </div>
              <button
                type="button"
                onClick={handleReset}
                className="flex items-center justify-center px-3 py-1.5 text-[12px] font-semibold text-[#7A6FA1] bg-[#f3f0ff] hover:bg-[#e9e4fc] rounded-lg transition-colors flex-shrink-0 mr-1 ml-1"
              >
                Reset
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Therapist / Invitations / Pending Approvals Panel */}
      <div className="overflow-hidden bg-white rounded-xl shadow-sm border border-gray-100">
        <div className="px-6 py-5 border-b border-gray-100">
          <h2 className="text-xl font-bold text-[#4B3E7C]">
            {activeTab === 'invitations'
              ? 'All Invitations'
              : activeTab === 'pending'
                ? 'Provider Requests'
                : 'All Providers'}
          </h2>
          <p className="text-[13px] font-medium text-gray-500 mt-0.5">
            {activeTab === 'invitations' ? (
              <>
                <span className="font-semibold text-gray-700">
                  {
                    invitationsList.filter((i: any) => i.status === 'pending')
                      .length
                  }
                </span>{' '}
                Invitation sent &nbsp;·&nbsp;
                <span className="font-semibold text-[#10b981]">
                  {
                    invitationsList.filter((i: any) => i.status === 'accepted')
                      .length
                  }
                </span>{' '}
                Request Received
              </>
            ) : activeTab === 'pending' ? (
              `Providers who have requested to join your agency and are awaiting review.`
            ) : (
              `${totalActiveRecords} active providers`
            )}
          </p>
        </div>
        <div
          className={
            activeTab === 'invitations' || activeTab === 'pending'
              ? ''
              : 'overflow-x-auto'
          }
        >
          {activeTab === 'pending' ? (
            <div>
              {pendingApprovalsLoading ? (
                <div className="p-6">
                  <TableShimmer columns={4} />
                </div>
              ) : pendingApprovalsList?.length === 0 ? (
                <div className="p-8 text-center">
                  <Notfound />
                </div>
              ) : (
                pendingApprovalsList?.map((approval: any) => {
                  const provider = approval.providerId || {}

                  const displayName =
                    `${provider.firstName || ''} ${provider.lastName || ''}`.trim() ||
                    'Unknown Provider'
                  const email = provider.email || ''
                  const phone = provider.phone || ''
                  const photo = provider.profilePhotoUrl || ''
                  // const location = provider._id

                  const initials = displayName
                    .split(' ')
                    .filter(Boolean)
                    .slice(0, 2)
                    .map((n: string) => n[0])
                    .join('')
                    .toUpperCase()
                  const approvalDate = approval.approvedAt || approval.updatedAt
                  return (
                    <div
                      key={approval._id}
                      className="flex items-center justify-between px-6 py-4 border-b border-gray-100 hover:bg-gray-50/60 transition-colors group"
                    >
                      {/* Left: Avatar + Info */}
                      <div className="flex items-center gap-4">
                        <div className="relative flex-shrink-0">
                          {photo ? (
                            <img
                              src={photo}
                              alt={displayName}
                              className="w-12 h-12 rounded-full object-cover border-2 border-white shadow"
                            />
                          ) : (
                            <div className="w-12 h-12 rounded-full bg-[#e9e4fc] flex items-center justify-center text-[#7A6FA1] font-bold text-sm border-2 border-white shadow">
                              {initials || (
                                <PersonIcon
                                  sx={{ fontSize: 22, color: '#7A6FA1' }}
                                />
                              )}
                            </div>
                          )}
                        </div>
                        <div>
                          <div className="flex items-center gap-2 mb-1">
                            <span className="font-bold text-[#4B3E7C] text-[15px]">
                              {displayName}
                            </span>
                          </div>

                          <div className="flex items-center gap-4 text-[12px] text-gray-500">
                            {email && (
                              <span className="flex items-center gap-1">
                                <MailOutlineIcon sx={{ fontSize: 13 }} />
                                {email}
                              </span>
                            )}
                            {phone && (
                              <span className="flex items-center gap-1">
                                <PhoneOutlinedIcon sx={{ fontSize: 13 }} />
                                {phone}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Right: Status + Actions */}
                      <div className="flex items-center gap-3">
                        {approval.approvalStatus === 'pending' ? (
                          <>
                            <div className="flex items-center gap-1.5 mr-2">
                              <AccessTimeIcon
                                sx={{ fontSize: 20, color: '#5E5873' }}
                              />
                              <span className="text-[10px] font-medium text-[#5E5873]">
                                Under Review
                              </span>
                            </div>
                            {hasPermission('provider.approve') && (
                              <button
                                onClick={() => handleOpenApprovalReview(approval)}
                                className="flex items-center gap-1.5 px-4 py-2 bg-[#7A6FA1] text-white text-[12px] font-semibold rounded-lg hover:bg-[#6c6191] transition-colors"
                              >
                                <VisibilityIcon sx={{ fontSize: 16 }} />
                                Review Request
                              </button>
                            )}
                            {hasPermission('provider.approve') && (
                              <button
                                onClick={() => handleRejectProvider(approval._id)}
                                className="flex items-center justify-center w-9 h-9 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
                                title="Reject"
                              >
                                <CloseIcon sx={{ fontSize: 20 }} />
                              </button>
                            )}
                          </>
                        ) : (
                          <div className="flex items-center gap-1.5 mr-2">
                            {approval.approvalStatus === 'approved' ? (
                              <CheckCircleIcon
                                sx={{ fontSize: 16, color: '#10B981' }}
                              />
                            ) : approval.approvalStatus === 'rejected' ? (
                              <CloseIcon
                                sx={{ fontSize: 16, color: '#EF4444' }}
                              />
                            ) : (
                              <HourglassEmptyIcon
                                sx={{ fontSize: 16, color: '#f59e0b' }}
                              />
                            )}
                            <span
                              className={`text-[13px] font-semibold capitalize ${
                                approval.approvalStatus === 'approved'
                                  ? 'text-emerald-500'
                                  : approval.approvalStatus === 'rejected'
                                    ? 'text-red-500'
                                    : 'text-amber-500'
                              }`}
                            >
                              {approval?.approvalStatus}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })
              )}
            </div>
          ) : activeTab === 'invitations' ? (
            <div>
              {loadingForShimmer ? (
                <div className="p-6">
                  <TableShimmer columns={4} />
                </div>
              ) : invitationsList?.length === 0 ? (
                <div className="p-8 text-center">
                  <Notfound />
                </div>
              ) : (
                invitationsList.map((invitation: any) => {
                  const isAccepted = invitation.status === 'accepted'
                  const provider = invitation.providerId
                  const displayName = provider
                    ? `${provider.firstName || ''} ${provider.lastName || ''}`.trim()
                    : invitation.providerName
                  const email = provider?.email || invitation.providerEmail
                  const phone = provider?.phone || ''
                  const photo = provider?.profilePhotoUrl || ''
                  const isActive = isProviderActive(provider)
                  const dateLabel = isAccepted
                    ? `Received on ${formatDateMMDDYY(invitation.acceptedAt)}`
                    : `Invited on ${formatDateMMDDYY(invitation.createdAt)}`
                  const initials = displayName
                    .split(' ')
                    .filter(Boolean)
                    .slice(0, 2)
                    .map((n: string) => n[0])
                    .join('')
                    .toUpperCase()

                  console.log(
                    'Rendering invitation item with provider data:',
                    invitation
                  )
                  return (
                    <div
                      key={invitation._id}
                      className="flex items-center justify-between px-6 py-4 border-b border-gray-100 hover:bg-gray-50/60 transition-colors group"
                    >
                      {/* Left: Avatar + Info */}
                      <div className="flex items-center gap-4">
                        <div className="relative flex-shrink-0">
                          {photo ? (
                            <img
                              src={photo}
                              alt={displayName}
                              className="w-12 h-12 rounded-full object-cover border-2 border-white shadow"
                            />
                          ) : (
                            <div className="w-12 h-12 rounded-full bg-[#e9e4fc] flex items-center justify-center text-[#7A6FA1] font-bold text-sm border-2 border-white shadow">
                              {initials || (
                                <PersonIcon
                                  sx={{ fontSize: 22, color: '#7A6FA1' }}
                                />
                              )}
                            </div>
                          )}
                          {isActive && (
                            <span className="absolute bottom-0 right-0 w-3.5 h-3.5 bg-green-500 border-2 border-white rounded-full" />
                          )}
                        </div>
                        <div>
                          <div className="flex items-center gap-2 mb-1">
                            <span className="font-bold text-[#4B3E7C] text-[15px]">
                              {displayName}
                            </span>
                            {(invitation?.providerId?.specialization || [])
                              .length > 0 && (
                              <span className="px-1.5 py-0.5 text-[9px] font-bold text-[#7A6FA1] bg-[#e9e4fc] rounded uppercase tracking-wide">
                                {(invitation?.providerId?.specialization || [])
                                  .map((s: any) =>
                                    typeof s === 'string'
                                      ? s
                                      : s?.name || s?.title || '--'
                                  )
                                  .join(', ')}
                              </span>
                            )}
                            <span
                              className={`px-1.5 py-0.5 text-[9px] font-bold rounded uppercase tracking-wide ${
                                invitation.status === 'accepted'
                                  ? 'text-[#2F855A] bg-[#E6F7EE]'
                                  : invitation.status === 'pending'
                                    ? 'text-[#B7791F] bg-[#FEF3C7]'
                                    : invitation.status === 'revoked'
                                      ? 'text-[#C53030] bg-[#FEE2E2]'
                                      : 'text-[#7A6FA1] bg-[#E9E4FC]'
                              }`}
                            >
                              {invitation.status}
                            </span>
                          </div>

                          <div className="flex items-center gap-4 text-[12px] text-gray-500">
                            {email && (
                              <span className="flex items-center gap-1">
                                <MailOutlineIcon sx={{ fontSize: 13 }} />
                                {email}
                              </span>
                            )}
                            {phone && (
                              <span className="flex items-center gap-1">
                                <PhoneOutlinedIcon sx={{ fontSize: 13 }} />
                                {phone}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Right: Status + Actions */}

                      <div className="flex items-center gap-3">
                        <div className="text-right">
                          {isAccepted ? (
                            <div className="flex items-center gap-1.5 justify-end">
                              <CheckCircleIcon
                                sx={{ fontSize: 16, color: '#10b981' }}
                              />
                              <span className="text-[13px] font-semibold text-[#10b981]">
                                Provider Request Received
                              </span>
                            </div>
                          ) : (
                            <div className="flex items-center gap-1.5 justify-end">
                              <MailOutlineIcon
                                sx={{ fontSize: 16, color: '#6b7280' }}
                              />
                              <span className="text-[13px] font-semibold text-gray-500">
                                Provider Invitation Sent
                              </span>
                            </div>
                          )}
                          <p className="text-[11px] text-gray-400 mt-0.5 text-right">
                            {dateLabel}
                          </p>
                        </div>
                        <IconButton
                          size="small"
                          onClick={e => {
                            handleOpenMenu(e, invitation)
                            setAgencySelectedTherapist(invitation)
                          }}
                          sx={{
                            color: '#9ca3af',
                            '&:hover': { color: '#4B3E7C' },
                          }}
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      </div>
                    </div>
                  )
                })
              )}
            </div>
          ) : (
            <table className="min-w-full">
              <thead className="bg-[#e9e4fc]">
                <tr className="text-[10px] text-left text-[#7A6FA1] uppercase tracking-widest font-bold whitespace-nowrap">
                  <th
                    className="px-6 py-3 font-medium cursor-pointer"
                    onClick={() => handleSort('firstName')}
                  >
                    <div className="flex items-center">
                      PROVIDER NAME & ROLE
                      {/* {getSortIcon('firstName')} */}
                    </div>
                  </th>
                  <th
                    className="px-6 py-3 font-medium cursor-pointer"
                    onClick={() => handleSort('email')}
                  >
                    <div className="flex items-center">
                      LOCATION
                      {/* {getSortIcon('email')} */}
                    </div>
                  </th>
                  <th
                    className="px-6 py-3 font-medium cursor-pointer"
                    onClick={() => handleSort('phone')}
                  >
                    <div className="flex items-center">
                      INSURANCES
                      {/* {getSortIcon('phone')} */}
                    </div>
                  </th>

                  <th
                    className="px-6 py-3 font-medium cursor-pointer"
                    onClick={() => handleSort('gender')}
                  >
                    <div className="flex items-center">
                      DETAILS
                      {/* {getSortIcon('gender')} */}
                    </div>
                  </th>
                  <th
                    className="px-6 py-3 font-medium cursor-pointer"
                    onClick={() => handleSort('createdAt')}
                  >
                    <div className="flex items-center">
                      SERVICE STATUS
                      {/* {getSortIcon('createdAt')} */}
                    </div>
                  </th>
                  <th className="px-6 py-3 font-medium">VISITS</th>
                  <th className="px-6 py-3 font-medium">ACTION</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {loadingForShimmer ? (
                  <TableShimmer columns={7} />
                ) : therapists?.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="p-4 text-center">
                      <Notfound />
                    </td>
                  </tr>
                ) : (
                  therapists.map(therapist => (
                    <tr
                      key={therapist._id}
                      className="border-b border-[#ECEAF3] hover:bg-[#FAFAFC] transition whitespace-nowrap"
                    >
                      <td className="px-8 py-8 align-top">
                        <div className="flex items-center gap-5">
                          <div className="relative flex-shrink-0">
                            <Avatar
                              src={therapist?.profilePhotoUrl}
                              alt={therapist?.firstName}
                              sx={{
                                width: 70,
                                height: 70,
                                bgcolor: '#E5E7EB',
                                color: '#64748B',
                                borderRadius: '18px',
                              }}
                            />
                            {isProviderActive(therapist) && (
                              <span className="absolute bottom-1 right-0 w-4 h-4 bg-[#39B273] border-2 border-white rounded-full"></span>
                            )}
                          </div>
                          <div>
                            <h3
                              className="text-[14px] font-bold text-[#59517D] leading-none cursor-pointer hover:underline"
                              onClick={() =>
                                handleOpenProviderDetailsDialog(therapist)
                              }
                            >
                              {therapist?.firstName} {therapist?.lastName}
                            </h3>
                            {(therapist?.specialization || []).length > 0 && (
                              <div className="flex flex-wrap gap-2 mt-2">
                                {(therapist?.specialization || []).map(
                                  (spec: any, idx: number) => (
                                    <div
                                      key={idx}
                                      className="inline-flex bg-[#EDE9F8] rounded-sm px-2 py-1"
                                    >
                                      <span className="text-[#6E67A5] text-[12px] uppercase">
                                        {typeof spec === 'string'
                                          ? spec
                                          : spec?.name || spec?.title || '--'}
                                      </span>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                            <div className="flex flex-col gap-0.5 mt-2">
                              <div className="flex items-center gap-1.5 text-[12px] text-[#574F75]">
                                <MailOutlineIcon sx={{ fontSize: 14 }} />{' '}
                                {therapist?.email || '--'}
                              </div>
                              <div className="flex items-center gap-1.5 text-[12px] text-[#574F75]">
                                <PhoneOutlinedIcon sx={{ fontSize: 14 }} />{' '}
                                {therapist?.phone || '--'}
                              </div>
                            </div>
                            <div className="mt-2">
                              {isProviderActive(therapist) ? (
                                <span className="inline-flex items-center px-3 py-1 rounded-sm bg-[#E6F7EE] text-[#2F855A] text-[10px] font-semibold">
                                  Active
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-3 py-1 rounded-sm bg-[#FEE2E2] text-[#C53030] text-[10px] font-semibold">
                                  Inactive
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </td>

                      <td className="px-8 py-8 align-top">
                        <div className="flex flex-col">
                          <span className="font-semibold text-[#4B3E7C] text-[12px]">
                            {therapist?.addressLine}, {therapist?.city || '--'},
                            {therapist?.state || '--'} ,
                            {therapist?.country || '--'} ,{' '}
                            {therapist?.zipCode || '--'}
                          </span>
                        </div>
                      </td>
                      <td className="px-8 py-8 align-top">
                        <div className="flex flex-wrap gap-2 w-[300px]">
                          {(therapist?.insuranceAccepted || []).map(
                            (item: any, i: number) => (
                              <span
                                key={i}
                                className="px-2 py-1 text-[12px] text-[#7A6FA1] bg-[#f3f0ff] rounded break-words"
                              >
                                {item?.name || '--'}
                              </span>
                            )
                          )}
                        </div>
                      </td>
                      <td className="px-8 py-8 align-top">
                        <div className="flex flex-col">
                          <span className="font-semibold text-[#4B3E7C] text-[12px]">
                            {therapist?.gender
                              ? therapist.gender.charAt(0).toUpperCase() +
                                therapist.gender.slice(1).toLowerCase()
                              : '--'}
                          </span>

                          {(therapist?.providerPackage?.[0]?.language || [])
                            .length > 0 ? (
                            <div className="flex flex-wrap gap-2 mt-2 w-[200px]">
                              <span className="px-2 py-1 text-[12px] text-[#7A6FA1] bg-[#f3f0ff] rounded break-words">
                                {(
                                  therapist?.providerPackage?.[0]?.language ||
                                  []
                                ).join(', ')}
                              </span>
                            </div>
                          ) : null}
                        </div>
                      </td>

                      <td className="px-8 py-8 align-top">
                        <div className="flex flex-col">
                          {(() => {
                            const rates =
                              therapist?.providerPackage
                                ?.map((item: any) =>
                                  Number(item?.private_pay_rate)
                                )
                                ?.filter((rate: number) => !isNaN(rate)) || []

                            const minRate = rates.length
                              ? Math.min(...rates)
                              : 0
                            const maxRate = rates.length
                              ? Math.max(...rates)
                              : 0

                            return (
                              <span className="font-semibold text-[#4B3E7C] text-[12px]">
                                {minRate === maxRate
                                  ? minRate > 0
                                    ? `$${minRate}/${therapist?.providerPackage?.[0]?.session_length} mins`
                                    : ``
                                  : maxRate > 0
                                    ? `$${minRate} - $${maxRate}/${therapist?.providerPackage?.[0]?.session_length} mins`
                                    : `--`}
                              </span>
                            )
                          })()}

                          <span className="text-[12px] text-[#574F75] mt-1">
                            {therapist?.packageCount} Packages
                          </span>
                        </div>
                      </td>
                      <td className="px-8 py-8 align-top">
                        <div className="flex flex-col items-center">
                          <span className="text-[22px] font-bold text-[#4B3E7C] leading-none">
                            {therapist?.visits}
                          </span>
                          <span className="text-[8px] font-bold text-[#574F75] uppercase mt-1 tracking-widest">
                            TOTAL VISITS
                          </span>
                        </div>
                      </td>
                      <td className="px-8 py-8 align-top">
                        <IconButton
                          size="small"
                          onClick={e => {
                            ;(handleOpenMenu(e, therapist),
                              setAgencySelectedTherapist(therapist))
                          }}
                          sx={{ color: 'gray' }}
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <div className="flex justify-center mt-3">
        <div className="flex items-center gap-4">
          <RowsPerPageDropdown
            pageSize={pageSize}
            onPageSizeChange={newPageSize => {
              handlePageSizeChange(newPageSize)
              if (ourPageSize && ourPageSize !== newPageSize) {
                setCurrentPage(1)
              }
            }}
          />
        </div>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          className="mt-2 mt-md-0"
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      </div>
      <ToastContainer />
      <AreYouSurePopup
        open={openRemoveInvitationConfirm}
        onClose={() => setOpenRemoveInvitationConfirm(false)}
        onConfirm={async () => {
          if (agencySelectedTherapist?._id) {
            setIsRemovingInvitation(true)
            await handleRemoveInvitation(agencySelectedTherapist._id)
            setIsRemovingInvitation(false)
            setOpenRemoveInvitationConfirm(false)
          }
        }}
        title="Remove Invitation"
        message={`Are you sure you want to remove the invitation for ${
          agencySelectedTherapist?.therapistId
            ? `${agencySelectedTherapist.therapistId.firstName || ''} ${agencySelectedTherapist.therapistId.lastName || ''}`.trim()
            : agencySelectedTherapist?.providerName ||
              agencySelectedTherapist?.providerEmail ||
              'this provider'
        }?`}
        confirmText="Remove"
        cancelText="Cancel"
        isProcessing={isRemovingInvitation}
        type="danger"
      />
      <Dialog open={openToggle} onClose={() => setOpenToggle(false)}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to {isActive ? 'deactivate' : 'activate'} this
          provider?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenToggle(false)} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmToggle}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? 'Updating...' : isActive ? 'Deactivate' : 'Activate'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Provider Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 1.5,
            pt: 2.5,
            px: 3,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 48,
              height: 48,
              borderRadius: 2,
              bgcolor: 'error.lighter',
            }}
          >
            <DeleteForeverIcon sx={{ fontSize: 28, color: 'error.main' }} />
          </Box>
          <Box>
            <Typography variant="h6" component="span" fontWeight={600}>
              Delete Provider
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              display="block"
              mt={0.5}
            >
              This action cannot be undone
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ px: 3, py: 1 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to permanently delete this provider? All
            associated data will be removed.
          </Typography>
          {selectedProviderForDelete && (
            <Box
              sx={{
                p: 2,
                mb: 2,
                bgcolor: 'grey.50',
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>Provider:</strong> {''}
                {selectedProviderForDelete.firstName}{' '}
                {selectedProviderForDelete.lastName}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Email:</strong> {''}
                {selectedProviderForDelete.email}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            p: 2.5,
            px: 3,
            gap: 1.5,
            borderTop: 1,
            borderColor: 'divider',
          }}
        >
          <Button
            onClick={handleCloseDeleteDialog}
            disabled={deleteLoading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            disabled={deleteLoading}
            variant="contained"
            color="error"
            startIcon={
              deleteLoading ? null : <DeleteForeverIcon sx={{ fontSize: 18 }} />
            }
          >
            {deleteLoading ? 'Deleting...' : 'Delete Provider'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openReverifyDialog} onClose={handleCloseReverifyDialog}>
        <DialogTitle>Re-Verify Provider</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 1.5 }}>
            Are you sure you want to initiate re-verification for{' '}
            <strong>{reverifyProviderName || 'this provider'}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseReverifyDialog}
            variant="outlined"
            disabled={reverifyLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleReverifyProvider}
            color="primary"
            variant="contained"
            disabled={reverifyLoading}
          >
            {reverifyLoading ? 'Re-verifying...' : 'Confirm Re-Verification'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Commission Dialog */}
      <Dialog
        open={openCommissionDialog}
        onClose={handleCloseCommissionDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Per Claim System Fee & Discount</DialogTitle>
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {commissionData?.plan_id?.name && (
            <Typography sx={{ pt: 0.5 }}>
              <strong>Subscribed Plan:</strong> {commissionData?.plan_id?.name}
            </Typography>
          )}
          {commissionData?.plan_id?.monthly_fee &&
            commissionData?.plan_id?.anual_fee && (
              <Typography variant="body1" sx={{ mb: 0.2 }}>
                <strong>Subscription Fee:</strong>{' '}
                {commissionData?.frequency === 'Month'
                  ? `$${commissionData?.plan_id?.monthly_fee}`
                  : `$${commissionData?.plan_id?.anual_fee}`}
              </Typography>
            )}
          {commissionData?.plan_id?.commission && (
            <Typography variant="body1" sx={{ mb: 1.6 }}>
              <strong>Per-Claim System Fee:</strong>{' '}
              {`${commissionData?.plan_id?.commission}%`}
            </Typography>
          )}
          <TextField
            label="Per Claim System Fee"
            type="number"
            value={monthlyCommission}
            sx={{ mb: 1.6, mt: 1.6 }}
            onChange={e => {
              const inputValue = e.target.value
              // Allow only positive decimal numbers (up to 2 decimal places)
              if (inputValue === '' || parseFloat(inputValue) >= 0) {
                const validValue = inputValue.match(/^(\d*(\.\d{0,3})?)?$/)
                  ? inputValue
                  : monthlyCommission
                setMonthlyCommission(validValue)
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            helperText="Enter the Per Claim System Fee percentage"
          />
          {/* <TextField
            label="Yearly Commission"
            type="number"
            value={yearlyCommission}
            onChange={e => {
              const inputValue = e.target.value
              // Allow only positive decimal numbers (up to 2 decimal places)
              if (inputValue === '' || parseFloat(inputValue) >= 0) {
                const validValue = inputValue.match(/^(\d+(\.\d{0,2})?)?$/)
                  ? inputValue
                  : yearlyCommission
                setYearlyCommission(validValue)
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            helperText="Enter the yearly commission percentage"
          /> */}
          <TextField
            label="Per Claim System Fee Discount"
            type="number"
            value={providerFeeDiscountPercent}
            onChange={e => {
              const inputValue = e.target.value
              // Allow only positive decimal numbers (up to 2 decimal places) between 0-100
              if (inputValue === '' || parseFloat(inputValue) >= 0) {
                const validValue = inputValue.match(/^(\d*(\.\d{0,3})?)?$/)
                  ? inputValue
                  : providerFeeDiscountPercent
                // Check if value is within valid range (0-100)
                if (
                  validValue === '' ||
                  (parseFloat(validValue) >= 0 && parseFloat(validValue) <= 100)
                ) {
                  setProviderFeeDiscountPercent(validValue)
                }
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            helperText="Enter the Per Claim System Fee Discount (0-100)"
          />

          <Typography variant="body1" sx={{ mb: 1.6, mt: 1.6 }}>
            <strong>Final Per Claim Fee:</strong> {finalperclaimfeeDisplay}%
          </Typography>
          {/* if Final Per Claim Fee less than or equal to 0, show a error message */}
          {finalperclaimfee <= 0 && (
            <Typography variant="body2" color="error">
              The entered percentages result in a platform fee of 0 or less.
              Please update the values to maintain a minimum positive fee.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseCommissionDialog}
            disabled={commissionLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateCommission}
            variant="contained"
            color="primary"
            disabled={commissionLoading}
          >
            {commissionLoading ? 'Updating...' : 'Update'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Provider Verification Dialog */}
      <Dialog
        open={openVerificationDialog}
        onClose={handleCloseVerificationDialog}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 3,
            maxHeight: '90vh',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 2,
            pt: 3,
            px: 3,
            background: 'linear-gradient(135deg, #5BC0BE 0%, #4a9d9b 100%)',
            color: 'white',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <VerifiedUserIcon sx={{ fontSize: 28 }} />
            <Box>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, letterSpacing: 0.5 }}
              >
                Provider Verification Details
              </Typography>
            </Box>
          </Box>
          <IconButton
            onClick={handleCloseVerificationDialog}
            size="small"
            sx={{
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ pt: '1rem !important', pb: 2, px: 3, bgcolor: '#f8f9fa' }}
        >
          {selectedProvider && (
            <>
              <Grid container spacing={3}>
                {/* <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      mb: 2,
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <PersonOutlineIcon
                          sx={{ color: '#5BC0BE', fontSize: 28 }}
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Profile Information
                        </Typography>
                        {(() => {
                          if (
                            selectedProvider.status?.toLowerCase() === 'blocked'
                          ) {
                            return (
                              <Box
                                sx={{ display: 'flex', alignItems: 'center' }}
                              >
                                <Chip
                                  icon={
                                    <NoAccountsIcon sx={{ fontSize: 16 }} />
                                  }
                                  label="Blocked"
                                  sx={{
                                    backgroundColor: 'rgba(211, 47, 47, 0.2)',
                                    color: '#d32f2f',
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    height: 28,
                                    border: '1.5px solid #d32f2f',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                                    '& .MuiChip-icon': { color: '#d32f2f' },
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                      transform: 'translateY(-1px)',
                                      boxShadow:
                                        '0 4px 12px rgba(0, 0, 0, 0.2)',
                                    },
                                  }}
                                />
                              </Box>
                            )
                          }
                          if (
                            selectedProvider.status?.toLowerCase() === 'active'
                          ) {
                            return (
                              <Box
                                sx={{ display: 'flex', alignItems: 'center' }}
                              >
                                <Chip
                                  icon={<VerifiedIcon sx={{ fontSize: 16 }} />}
                                  label="Approved"
                                  sx={{
                                    backgroundColor: 'rgba(46, 125, 50, 0.2)',
                                    color: '#2e7d32',
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    height: 28,
                                    border: '1.5px solid #2e7d32',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                                    '& .MuiChip-icon': { color: '#2e7d32' },
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                      transform: 'translateY(-1px)',
                                      boxShadow:
                                        '0 4px 12px rgba(0, 0, 0, 0.2)',
                                    },
                                  }}
                                />
                              </Box>
                            )
                          }
                          return null
                        })()}
                      </Box>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Full Name
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              color: '#2c3e50',
                              fontSize: '1rem',
                            }}
                          >
                            {selectedProvider.firstName}{' '}
                            {selectedProvider.lastName}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Email
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.email || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Phone
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.phone || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Gender
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.gender || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Status
                          </Typography>
                          <Chip
                            label={
                              isProviderActive(selectedProvider)
                                ? 'Active'
                                : 'Inactive'
                            }
                            color={
                              isProviderActive(selectedProvider)
                                ? 'success'
                                : 'error'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Years of Experience
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.yearsOfExperience || '--'}
                          </Typography>
                        </Grid>
                        {selectedProvider.bio && (
                          <Grid item xs={12}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: '#6c757d',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                letterSpacing: 0.5,
                                fontSize: '0.7rem',
                                mb: 0.5,
                                display: 'block',
                              }}
                            >
                              Bio
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                mt: 0.5,
                                color: '#495057',
                                lineHeight: 1.7,
                                bgcolor: '#f8f9fa',
                                p: 1.5,
                                borderRadius: 1,
                              }}
                            >
                              {selectedProvider.bio}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                
                <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <LocationOnIcon
                          sx={{ color: '#5BC0BE', fontSize: 28 }}
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Address Information
                        </Typography>
                      </Box>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Address Line
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.addressLine || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            City
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.city || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            State
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.state || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Zip Code
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.zipCode || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Country
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.country || '--'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

              
                <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <AccountBalanceIcon
                          sx={{ color: '#5BC0BE', fontSize: 28 }}
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Billing Information
                        </Typography>
                      </Box>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Billing Type
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.billingType
                              ? selectedProvider.billingType
                                  .charAt(0)
                                  .toUpperCase() +
                                selectedProvider.billingType.slice(1)
                              : '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Provider NPI
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.providerNpi || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Billing NPI
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.billingNpi || '--'}
                          </Typography>
                        </Grid>
                        {selectedProvider.billingType?.toLowerCase() ===
                        'individual' ? (
                          <Grid item xs={12} sm={6}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: '#6c757d',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                letterSpacing: 0.5,
                                fontSize: '0.7rem',
                                mb: 0.5,
                                display: 'block',
                              }}
                            >
                              SSN
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 500,
                                color: '#495057',
                                fontSize: '0.95rem',
                              }}
                            >
                              {selectedProvider.ssn || '--'}
                            </Typography>
                          </Grid>
                        ) : (
                          <Grid item xs={12} sm={6}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: '#6c757d',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                letterSpacing: 0.5,
                                fontSize: '0.7rem',
                                mb: 0.5,
                                display: 'block',
                              }}
                            >
                              Tax ID
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 500,
                                color: '#495057',
                                fontSize: '0.95rem',
                              }}
                            >
                              {selectedProvider.taxId || '--'}
                            </Typography>
                          </Grid>
                        )}
                        {selectedProvider.companyName && (
                          <Grid item xs={12} sm={6}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: '#6c757d',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                letterSpacing: 0.5,
                                fontSize: '0.7rem',
                                mb: 0.5,
                                display: 'block',
                              }}
                            >
                              Company Name
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 500,
                                color: '#495057',
                                fontSize: '0.95rem',
                              }}
                            >
                              {selectedProvider.companyName}
                            </Typography>
                          </Grid>
                        )}
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Billing Phone
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.billingPhone || '--'}
                          </Typography>
                        </Grid>
                        {selectedProvider.billingAddressLine && (
                          <>
                            <Grid item xs={12}>
                              <Typography
                                variant="caption"
                                sx={{
                                  color: '#6c757d',
                                  fontWeight: 600,
                                  textTransform: 'uppercase',
                                  letterSpacing: 0.5,
                                  fontSize: '0.7rem',
                                  mb: 0.5,
                                  display: 'block',
                                }}
                              >
                                Billing Address
                              </Typography>
                              <Typography
                                variant="body1"
                                sx={{
                                  fontWeight: 500,
                                  color: '#495057',
                                  fontSize: '0.95rem',
                                }}
                              >
                                {selectedProvider.billingAddressLine}
                                {selectedProvider.billingCity &&
                                  `, ${selectedProvider.billingCity}`}
                                {selectedProvider.billingState &&
                                  `, ${selectedProvider.billingState}`}
                                {selectedProvider.billingZipCode &&
                                  ` ${selectedProvider.billingZipCode}`}
                              </Typography>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid> */}

                {/* Licenses Section */}
                {selectedProvider.licenses &&
                  selectedProvider.licenses.length > 0 && (
                    <Grid item xs={12}>
                      <Card
                        elevation={0}
                        sx={{
                          borderRadius: 2,
                          border: '1px solid',
                          borderColor: 'divider',
                          bgcolor: 'white',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                          },
                        }}
                      >
                        <CardContent sx={{ p: 3 }}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1.5,
                              mb: 3,
                              pb: 2,
                              borderBottom: '2px solid',
                              borderColor: '#5BC0BE',
                            }}
                          >
                            <BadgeIcon
                              sx={{ color: '#5BC0BE', fontSize: 28 }}
                            />
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 700,
                                color: '#2c3e50',
                                letterSpacing: 0.3,
                              }}
                            >
                              License Information
                            </Typography>
                          </Box>
                          <Grid container spacing={2}>
                            {(selectedProvider?.licenses || []).map(
                              (license: any, index: number) => (
                                <Grid item xs={12} key={index}>
                                  <Card
                                    elevation={0}
                                    sx={{
                                      p: 2.5,
                                      borderRadius: 2,
                                      border: '1px solid',
                                      borderColor: '#e9ecef',
                                      bgcolor: '#f8f9fa',
                                    }}
                                  >
                                    <Grid container spacing={3}>
                                      <Grid item xs={12} sm={6}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: '#6c757d',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: 0.5,
                                            fontSize: '0.7rem',
                                            mb: 0.5,
                                            display: 'block',
                                          }}
                                        >
                                          License Number
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontWeight: 600,
                                            color: '#2c3e50',
                                            fontSize: '0.95rem',
                                          }}
                                        >
                                          {license.licenseNumber || '--'}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={6}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: '#6c757d',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: 0.5,
                                            fontSize: '0.7rem',
                                            mb: 0.5,
                                            display: 'block',
                                          }}
                                        >
                                          License State
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontWeight: 500,
                                            color: '#495057',
                                            fontSize: '0.95rem',
                                          }}
                                        >
                                          {license.licenseState || '--'}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={6}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: '#6c757d',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: 0.5,
                                            fontSize: '0.7rem',
                                            mb: 0.5,
                                            display: 'block',
                                          }}
                                        >
                                          Expiry Date
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontWeight: 500,
                                            color: '#495057',
                                            fontSize: '0.95rem',
                                          }}
                                        >
                                          {license.expiryDate
                                            ? formatDateMMDDYY(
                                                license.expiryDate
                                              )
                                            : '--'}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={6}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: '#6c757d',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: 0.5,
                                            fontSize: '0.7rem',
                                            mb: 0.5,
                                            display: 'block',
                                          }}
                                        >
                                          License Status
                                        </Typography>
                                        <Chip
                                          label={license.licenseStatus || '--'}
                                          color={
                                            license.licenseStatus === 'Active'
                                              ? 'success'
                                              : 'default'
                                          }
                                          size="small"
                                          sx={{
                                            fontWeight: 600,
                                            height: 28,
                                            '& .MuiChip-label': {
                                              px: 1.5,
                                            },
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                  </Card>
                                </Grid>
                              )
                            )}
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}

                {/* {selectedProvider.insuranceAccepted &&
                  selectedProvider.insuranceAccepted.length > 0 && (
                    <Grid item xs={12}>
                      <Card
                        elevation={0}
                        sx={{
                          borderRadius: 2,
                          border: '1px solid',
                          borderColor: 'divider',
                          bgcolor: 'white',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                          },
                        }}
                      >
                        <CardContent sx={{ p: 3 }}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1.5,
                              mb: 3,
                              pb: 2,
                              borderBottom: '2px solid',
                              borderColor: '#5BC0BE',
                            }}
                          >
                            <HealthAndSafetyIcon
                              sx={{ color: '#5BC0BE', fontSize: 28 }}
                            />
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 700,
                                color: '#2c3e50',
                                letterSpacing: 0.3,
                              }}
                            >
                              Accepted Insurances
                            </Typography>
                          </Box>
                          <Box
                            sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}
                          >
                            {(selectedProvider?.insuranceAccepted || []).map(
                              (insurance: any, index: number) => (
                                <Chip
                                  key={index}
                                  label={insurance.name || '--'}
                                  sx={{
                                    bgcolor: '#e3f2fd',
                                    color: '#1976d2',
                                    fontWeight: 600,
                                    border: '1px solid #90caf9',
                                    '&:hover': {
                                      bgcolor: '#bbdefb',
                                    },
                                  }}
                                  size="medium"
                                />
                              )
                            )}
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}

                
                <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <InfoIcon sx={{ color: '#5BC0BE', fontSize: 28 }} />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Additional Information
                        </Typography>
                      </Box>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Bank Connected
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isConnectBank ? 'Yes' : 'No'
                            }
                            color={
                              selectedProvider.isConnectBank
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Subscription Taken
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isSubscriptionTaken
                                ? 'Yes'
                                : 'No'
                            }
                            color={
                              selectedProvider.isSubscriptionTaken
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Service Created
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isServiceCreated ? 'Yes' : 'No'
                            }
                            color={
                              selectedProvider.isServiceCreated
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Slot Added
                          </Typography>
                          <Chip
                            label={selectedProvider.isSlotAdded ? 'Yes' : 'No'}
                            color={
                              selectedProvider.isSlotAdded
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Accepts New Patients
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isAcceptNewPatientEnq
                                ? 'Yes'
                                : 'No'
                            }
                            color={
                              selectedProvider.isAcceptNewPatientEnq
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            HIPAA Signed
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.hasSignedHIPAA ? 'Yes' : 'No'
                            }
                            color={
                              selectedProvider.hasSignedHIPAA
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Onboarding Date
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              color: '#2c3e50',
                              fontSize: '0.95rem',
                            }}
                          >
                            {formatDateMMDDYY(selectedProvider.createdAt) ||
                              '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Last Updated
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              color: '#2c3e50',
                              fontSize: '0.95rem',
                            }}
                          >
                            {formatDateMMDDYY(selectedProvider.updatedAt) ||
                              '--'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid> */}

                {/* Verification Status Section - at end of content */}
                <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <VerifiedUserIcon
                          sx={{ color: '#5BC0BE', fontSize: 28 }}
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Verification Status
                        </Typography>
                      </Box>
                      <Stack spacing={0} sx={{ width: '100%' }}>
                        {[
                          {
                            title: 'License Verification',
                            status:
                              selectedProvider.verificationStatus || 'N/A',
                            message:
                              selectedProvider.verificationMessage || '--',
                          },
                          {
                            title: 'FACIS Verification',
                            status:
                              selectedProvider.verificationFacisStatus || 'N/A',
                            message:
                              selectedProvider.verificationFacisMessage || '--',
                          },
                          {
                            title: 'Board Verification',
                            status:
                              selectedProvider.verificationBoardStatus || 'N/A',
                            message:
                              selectedProvider.verificationBoardMessage || '--',
                          },
                        ].map((item, index) => {
                          const getChipStyle = (s: string) => {
                            const sUpper = String(s).toLowerCase()
                            if (sUpper === 'verified')
                              return {
                                // bgcolor: 'rgba(46, 125, 50, 0.12)',
                                color: '#2e7d32',
                                // border: '1px solid rgba(46, 125, 50, 0.5)',
                              }
                            if (sUpper === 'pending')
                              return {
                                // bgcolor: 'rgba(237, 108, 2, 0.12)',
                                color: '#ed6c02',
                                // border: '1px solid rgba(237, 108, 2, 0.5)',
                              }
                            if (sUpper === 'expired' || sUpper === 'rejected')
                              return {
                                // bgcolor: 'rgba(211, 47, 47, 0.12)',
                                color: '#d32f2f',
                                // border: '1px solid rgba(211, 47, 47, 0.5)',
                              }
                            if (sUpper === 'submitted')
                              return {
                                // bgcolor: 'rgba(2, 136, 209, 0.12)', // soft info blue background
                                color: '#0288d1', // info main
                                // border: '1px solid rgba(2, 136, 209, 0.5)',
                              }

                            return {
                              // bgcolor: 'rgba(108, 117, 125, 0.12)',
                              color: '#6c757d',
                              // border: '1px solid rgba(108, 117, 125, 0.3)',
                            }
                          }
                          const chipStyle = getChipStyle(item.status)
                          return (
                            <Box
                              key={item.title}
                              sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 2,
                                py: 1.75,
                                px: 1.5,
                                borderBottom: index < 2 ? '1px solid' : 'none',
                                borderColor: '#e9ecef',
                              }}
                            >
                              <Box
                                sx={{
                                  minWidth: 180,
                                  flexShrink: 0,
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    color: '#2c3e50',
                                    fontWeight: 700,
                                    fontSize: '0.875rem',
                                    letterSpacing: 0.3,
                                    lineHeight: 1.4,
                                  }}
                                >
                                  {item.title}
                                </Typography>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    mt: 2,
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: '#868e96',
                                      fontWeight: 500,
                                      fontSize: '0.7rem',
                                    }}
                                  >
                                    Status:
                                  </Typography>
                                  {/* <Chip
                                    label={item.status}
                                    size="small"
                                    sx={{
                                      fontWeight: 600,
                                      height: 22,
                                      fontSize: '0.7rem',
                                      ...chipStyle,
                                    }}
                                  /> */}
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 800,
                                      fontSize: '0.8rem',
                                      ...chipStyle,
                                    }}
                                  >
                                    {item.status}
                                  </Typography>
                                </Box>
                              </Box>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: '#495057',
                                  fontSize: '0.8125rem',
                                  lineHeight: 1.5,
                                  flex: 1,
                                  pt: 0.25,
                                }}
                              >
                                {item.message}
                              </Typography>
                            </Box>
                          )
                        })}
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Block Reason - at very end of content */}
                {selectedProvider.blockReason && (
                  <Grid item xs={12}>
                    <Alert
                      severity="error"
                      icon={<BlockIcon />}
                      sx={{
                        borderRadius: 2,
                        '& .MuiAlert-message': { width: '100%' },
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 600, mb: 0.5 }}
                      >
                        Block Reason
                      </Typography>
                      <Typography variant="body2">
                        {selectedProvider.blockReason}
                      </Typography>
                    </Alert>
                  </Grid>
                )}
              </Grid>
            </>
          )}
        </DialogContent>
        {selectedProvider && (
          <>
            <Divider sx={{ borderColor: '#e9ecef' }} />
            <DialogActions
              sx={{
                px: 3,
                py: 2.5,
                bgcolor: '#f8f9fa',
                borderTop: '1px solid',
                borderColor: '#e9ecef',
                justifyContent: 'flex-end',
                gap: 1.5,
              }}
            >
              {selectedProvider.status?.toLowerCase() !== 'active' && hasPermission('provider.approve') && (
                <Button
                  onClick={handleApproveTherapist}
                  variant="contained"
                  color="success"
                  disabled={approveLoading || blockLoading}
                  startIcon={<CheckCircleIcon />}
                  sx={{
                    px: 3,
                    py: 1,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                    },
                  }}
                >
                  {approveLoading ? 'Approving...' : 'Approve Provider'}
                </Button>
              )}
              {selectedProvider.status?.toLowerCase() !== 'blocked' && hasPermission('provider.edit') && (
                <Button
                  onClick={handleOpenBlockReasonDialog}
                  variant="contained"
                  color="error"
                  disabled={approveLoading || blockLoading}
                  startIcon={<BlockIcon />}
                  sx={{
                    px: 3,
                    py: 1,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(211, 47, 47, 0.3)',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(211, 47, 47, 0.4)',
                    },
                  }}
                >
                  Block Provider
                </Button>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Block Reason Dialog */}
      <Dialog
        open={openBlockReasonDialog}
        onClose={handleCloseBlockReasonDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <BlockIcon sx={{ color: 'error.main', fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Block Provider
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: '1rem !important', pb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Please provide a reason for blocking this provider. This reason will
            be displayed to the provider in to their account.
          </Typography>
          <TextField
            label="Reason for Blocking"
            multiline
            rows={4}
            fullWidth
            value={blockReason}
            onChange={e => setBlockReason(e.target.value)}
            placeholder="Enter the reason for blocking this provider..."
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              },
            }}
            helperText={`${blockReason.length} characters`}
          />
        </DialogContent>
        <Divider />
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={handleCloseBlockReasonDialog}
            variant="outlined"
            disabled={blockLoading}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmBlock}
            variant="contained"
            color="error"
            disabled={blockLoading || !blockReason.trim()}
            startIcon={<BlockIcon />}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: '0 2px 8px rgba(211, 47, 47, 0.3)',
              '&:hover': {
                boxShadow: '0 4px 12px rgba(211, 47, 47, 0.4)',
              },
            }}
          >
            {blockLoading ? 'Blocking...' : 'Confirm Block'}
          </Button>
        </DialogActions>
      </Dialog>

      <TablePopup
        open={openTablePopup}
        handleClose={() => setOpenTablePopup(false)}
        data={tableData}
        title={tableTitle}
      />
      <PendingApprovalReviewDialog
        open={openApprovalReview}
        onClose={handleCloseApprovalReview}
        approval={selectedApproval}
        onApprove={approvalId => {
          handleApproveProvider(approvalId)
          handleCloseApprovalReview()
        }}
        onReject={approvalId => {
          handleRejectProvider(approvalId)
          handleCloseApprovalReview()
        }}
      />

      {/* Right side Drawer for Pending Approval Review */}

      {/* Row Dropdown Menu */}
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleCloseMenu}
        PaperProps={{
          sx: {
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
            border: '1px solid #f0f0f0',
            minWidth: '220px',
            mt: 0.5,
            p: 0.5,
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {(activeTab !== 'invitations' ||
          selectedTherapistForMenu?.status === 'accepted') && (
          <MenuItem
            onClick={() => {
              const resolveTherapistId = () => {
                if (activeTab === 'invitations') {
                  const isAccepted =
                    selectedTherapistForMenu?.status === 'accepted'
                  if (isAccepted) {
                    return (
                      selectedTherapistForMenu?.providerId?._id ||
                      selectedTherapistForMenu?.providerId ||
                      selectedTherapistForMenu?._id ||
                      null
                    )
                  }

                  return agencySelectedTherapist?._id || null
                }

                return (
                  agencySelectedTherapist?._id ||
                  selectedTherapistForMenu?._id ||
                  null
                )
              }

              const therapistId = resolveTherapistId()
              if (therapistId) {
                handleViewProfile(therapistId)
              } else {
                toast.error(
                  'Provider profile is not available for this invitation.'
                )
              }
            }}
            sx={{
              borderRadius: '8px',
              py: 1.2,
              px: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              color: '#4B3E7C',
              fontWeight: 500,
              fontSize: '14px',
              '&:hover': {
                bgcolor: '#f8f7fd',
              },
            }}
          >
            <VisibilityIcon sx={{ fontSize: 18, color: '#7A6FA1' }} />
            View Profile
          </MenuItem>
        )}

        {/* <MenuItem
          // onClick={() => handleViewPayOutSettings()}
          sx={{
            borderRadius: '8px',
            py: 1.2,
            px: 2,
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            color: '#4B3E7C',
            fontWeight: 500,
            fontSize: '14px',
            '&:hover': {
              bgcolor: '#f8f7fd',
            },
          }}
        >
          <CalendarTodayIcon sx={{ fontSize: 18, color: '#7A6FA1' }} />
          View Schedule
        </MenuItem> */}

        {activeTab === 'invitations' || !hasPermission('provider.edit') ? null : (
          <>
            <MenuItem
              onClick={() =>
                handleNavigatePackageManagement(agencySelectedTherapist?._id)
              }
              sx={{
                borderRadius: '8px',
                py: 1.2,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                color: '#4B3E7C',
                fontWeight: 500,
                fontSize: '14px',
                '&:hover': {
                  bgcolor: '#f8f7fd',
                },
              }}
            >
              <SyncAltIcon sx={{ fontSize: 18, color: '#7A6FA1' }} />
              Package Management
            </MenuItem>

            <MenuItem
              onClick={() =>
                handleViewPayOutSettings(agencySelectedTherapist?._id)
              }
              sx={{
                borderRadius: '8px',
                py: 1.2,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                color: '#4B3E7C',
                fontWeight: 500,
                fontSize: '14px',
                '&:hover': {
                  bgcolor: '#f8f7fd',
                },
              }}
            >
              <PaymentsIcon sx={{ fontSize: 18, color: '#7A6FA1' }} />
              Payout Setting
            </MenuItem>

            {hasPermission('provider.edit') && (
              <MenuItem
                onClick={() =>
                  handleOpenProviderStatusDialog(agencySelectedTherapist)
                }
                disabled={providerStatusLoading}
                sx={{
                  borderRadius: '8px',
                  py: 1.2,
                  px: 2,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  color: isProviderActive(agencySelectedTherapist)
                    ? '#E53E3E'
                    : '#2F855A',
                  fontWeight: 500,
                  fontSize: '14px',
                  '&:hover': {
                    bgcolor: isProviderActive(agencySelectedTherapist)
                      ? '#FFF5F5'
                      : '#ECFDF5',
                  },
                }}
              >
                {isProviderActive(agencySelectedTherapist) ? (
                  <ToggleOffIcon sx={{ fontSize: 18, color: '#E53E3E' }} />
                ) : (
                  <ToggleOnIcon sx={{ fontSize: 18, color: '#2F855A' }} />
                )}
                {isProviderActive(agencySelectedTherapist)
                  ? 'Disable Provider'
                  : 'Enable Provider'}
              </MenuItem>
            )}
          </>
        )}

        {activeTab === 'invitations' ? null : (
          <Divider sx={{ my: 1, borderColor: '#f0f0f0' }} />
        )}
        {activeTab !== 'invitations' && hasPermission('provider.delete') && (
          <MenuItem
            onClick={() => {
              handleCloseMenu()
              setOpenRemoveDialog(true)
            }}
            sx={{
              borderRadius: '8px',
              py: 1.2,
              px: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              color: '#e0533c',
              fontWeight: 500,
              fontSize: '14px',
              '&:hover': {
                bgcolor: '#fff5f5',
              },
            }}
          >
            <DeleteOutlineIcon sx={{ fontSize: 18, color: '#e0533c' }} />
            Remove from Agency
          </MenuItem>
        )}
        {activeTab === 'invitations' &&
        agencySelectedTherapist?.status !== 'accepted' &&
        hasPermission('provider.delete') ? (
          <MenuItem
            onClick={() => {
              handleCloseMenu()
              setOpenRemoveInvitationConfirm(true)
            }}
            sx={{
              borderRadius: '8px',
              py: 1.2,
              px: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              color: '#e0533c',
              fontWeight: 500,
              fontSize: '14px',
              '&:hover': {
                bgcolor: '#fff5f5',
              },
            }}
          >
            <DeleteOutlineIcon sx={{ fontSize: 18, color: '#e0533c' }} />
            Revoke from Invitation
          </MenuItem>
        ) : null}
      </Menu>

      {/* Invite Provider Dialog */}
      <Dialog
        open={openInviteDialog}
        onClose={!inviteLoading ? handleCloseInviteDialog : undefined}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: { borderRadius: '24px', padding: '16px' },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ color: '#4B3E7C', fontWeight: 'bold' }}
          >
            Invite Provider
          </Typography>
          <IconButton
            onClick={handleCloseInviteDialog}
            disabled={inviteLoading}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pb: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 1 }}>
            <Box>
              <Typography
                variant="body2"
                sx={{ color: '#4B3E7C', fontWeight: 'medium', mb: 1 }}
              >
                Full Name
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Jane Smith"
                value={inviteName}
                onChange={e => setInviteName(e.target.value)}
                disabled={inviteLoading}
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '12px',
                  },
                }}
              />
            </Box>
            <Box>
              <Typography
                variant="body2"
                sx={{ color: '#4B3E7C', fontWeight: 'medium', mb: 1 }}
              >
                Email Address
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="provider@example.com"
                value={inviteEmail}
                onChange={e => setInviteEmail(e.target.value)}
                disabled={inviteLoading}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MailOutlineIcon
                        sx={{ color: '#A0AEC0', fontSize: 20 }}
                      />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '12px',
                  },
                }}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ px: 3, pb: 2, pt: 0, justifyContent: 'center', gap: 2 }}
        >
          <Button
            onClick={handleCloseInviteDialog}
            disabled={inviteLoading}
            variant="outlined"
            sx={{
              borderRadius: '12px',
              color: '#4B3E7C',
              borderColor: '#4B3E7C',
              textTransform: 'none',
              fontWeight: 'bold',
              px: 4,
              py: 1,
              '&:hover': {
                borderColor: '#4B3E7C',
                backgroundColor: 'rgba(75, 62, 124, 0.04)',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleInviteProvider}
            disabled={inviteLoading}
            variant="contained"
            startIcon={<MailOutlineIcon />}
            sx={{
              borderRadius: '12px',
              backgroundColor: '#7A6FA1',
              color: 'white',
              textTransform: 'none',
              fontWeight: 'bold',
              px: 4,
              py: 1,
              '&:hover': {
                backgroundColor: '#6c6191',
              },
            }}
          >
            {inviteLoading ? 'Sending...' : 'Send Invitation'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Remove Provider Dialog */}
      <Dialog
        open={openRemoveDialog}
        onClose={!removeLoading ? () => setOpenRemoveDialog(false) : undefined}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: { borderRadius: '24px', padding: '16px' },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ color: '#e0533c', fontWeight: 'bold' }}
          >
            Remove Provider
          </Typography>
          <IconButton
            onClick={() => setOpenRemoveDialog(false)}
            disabled={removeLoading}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pb: 3 }}>
          <Typography variant="body1" sx={{ color: '#4B3E7C', mt: 1 }}>
            Are you sure you want to remove this provider from your agency? This
            action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'space-between' }}>
          <Button
            onClick={() => setOpenRemoveDialog(false)}
            disabled={removeLoading}
            variant="outlined"
            sx={{
              borderRadius: '12px',
              color: '#4B3E7C',
              borderColor: '#4B3E7C',
              textTransform: 'none',
              fontWeight: 'bold',
              px: 4,
              py: 1,
              '&:hover': {
                borderColor: '#4B3E7C',
                backgroundColor: 'rgba(75, 62, 124, 0.04)',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleRemoveProvider}
            disabled={removeLoading}
            variant="contained"
            startIcon={<DeleteOutlineIcon />}
            sx={{
              borderRadius: '12px',
              backgroundColor: '#e0533c',
              color: 'white',
              textTransform: 'none',
              fontWeight: 'bold',
              px: 4,
              py: 1,
              '&:hover': {
                backgroundColor: '#c94a36',
              },
            }}
          >
            {removeLoading ? 'Removing...' : 'Remove'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Provider Status Toggle Confirmation Dialog */}
      <Dialog
        open={openProviderStatusDialog}
        onClose={() =>
          !providerStatusLoading && setOpenProviderStatusDialog(false)
        }
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 30px 80px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <DialogTitle sx={{ px: 3, pt: 3, pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                width: 46,
                height: 46,
                borderRadius: '50%',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: isProviderActive(agencySelectedTherapist)
                  ? '#FFE5E5'
                  : '#E6F7EE',
              }}
            >
              {isProviderActive(agencySelectedTherapist) ? (
                <ToggleOffIcon sx={{ fontSize: 24, color: '#E53E3E' }} />
              ) : (
                <ToggleOnIcon sx={{ fontSize: 24, color: '#2F855A' }} />
              )}
            </Box>
            <Box>
              <Typography
                sx={{ fontSize: 18, fontWeight: 700, color: '#312E4A' }}
              >
                {isProviderActive(agencySelectedTherapist)
                  ? 'Disable Provider'
                  : 'Enable Provider'}
              </Typography>
              <Typography sx={{ fontSize: 13, color: '#6C6B7E' }}>
                {isProviderActive(agencySelectedTherapist)
                  ? 'Confirm disabling access for this provider.'
                  : 'Confirm enabling access for this provider.'}
              </Typography>
            </Box>
          </Box>
        </DialogTitle>

        <Divider sx={{ my: 1, borderColor: '#E6E8F0' }} />

        <DialogContent sx={{ px: 3, pb: 2 }}>
          <Typography
            sx={{
              fontSize: '15px',
              color: '#4B4A5A',
              mb: 1.5,
              lineHeight: 1.7,
            }}
          >
            Are you sure you want to{' '}
            {isProviderActive(agencySelectedTherapist) ? 'disable' : 'enable'}{' '}
            <strong>
              {agencySelectedTherapist?.firstName
                ? `${agencySelectedTherapist.firstName} ${agencySelectedTherapist.lastName || ''}`
                : 'this provider'}
            </strong>
            ?
          </Typography>
          <Typography sx={{ fontSize: '13px', color: '#6C6B7E' }}>
            This action will{' '}
            {isProviderActive(agencySelectedTherapist)
              ? 'prevent the provider from accessing agency features'
              : 'restore access for the provider'}
            .
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button
            onClick={() => setOpenProviderStatusDialog(false)}
            disabled={providerStatusLoading}
            variant="outlined"
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              color: '#4B4A5A',
              borderColor: '#E6E8F0',
              textTransform: 'none',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmProviderStatus}
            variant="contained"
            color={
              isProviderActive(agencySelectedTherapist) ? 'error' : 'success'
            }
            disabled={providerStatusLoading}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              boxShadow: isProviderActive(agencySelectedTherapist)
                ? '0 12px 20px rgba(229, 62, 62, 0.18)'
                : '0 12px 20px rgba(45, 133, 90, 0.18)',
            }}
          >
            {providerStatusLoading
              ? 'Saving...'
              : isProviderActive(agencySelectedTherapist)
                ? 'Disable Provider'
                : 'Enable Provider'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default AgencyProviderManagement
